import React, { useRef } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { enumUtil } from "../../../../utils/Enum"
import FormValidator from "../../../../utils/FormValidator"
import NotificationHandler from "../../../../utils/NotificationHandler"
import { GetZipCode, ServerRequestClearnigHouse, ServerRequestProtected, ServerRequestPublic } from "../../../../utils/ServerDataRequest"
import isNull from "../../../../utils/NullChecking"
import States, { AdmissionStatusDropDown, Class, LanguageProficiencyDropdown, SmokingStatusDropdown, PreferredCareGiverGender, PreferredCommunication, PreferredLanguage, PrimaryContactType, ASAMLevelOfCareDropdown, LOCUSLevelOfCareDropdown, LOCFrameworkDropdown } from "../../../../utils/Constants"
import { EmploymentStatus, StudentStatus, BirthOrder, GenderIdentity, SexualOrientation, BloodGroup } from '../../../../utils/Constants';
import { useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import format from 'date-fns/format';
////////
import { MaritalStatus } from '../../../../utils/Constants';
import Loader from '../../../shared/Loader/Loader';
import DiscardChangesPopup from '../../../shared/DiscardChanges/DiscardChangesPopup';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { GenderDemographic } from '../../../../utils/Constants';
import { addDays } from 'date-fns';
import handleNumericCheck from '../../../../utils/HandleNumericKeys';
import SuperSearchList from '../../../shared/SuperSearch/SuperSearchList';
import { useDispatch } from 'react-redux';
import { PatientRecordAction } from '../../../../actions/PatientActions';
import { OpenNewPatientTabAction } from '../../../../actions/PatientActions';
import { GeneralDropDowns } from '../../../../actions/GeneralPatientActions';
import FormatDate from '../../../shared/DateFormatter';
import handleAlphabeticCheck from '../../../../utils/HandleAlphabetKeys';
import FormatPhoneNumber from '../../../../utils/FormatPhoneNumber';
import ReactInputMask from 'react-input-mask';
import DropdownValueHandler from '../../../shared/SuperSearch/DropdownValueHandler'
import DatePicker from '../../../General/DatePicker';
import { useMemo } from 'react';
import OpenQuickPopup from '../../../shared/OpenQuickPopup/OpenQuickPopup';
import SuperSearchMultiple from '../../../shared/SuperSearch/SuperSearchMultiple';
import DeleteConfirmatiom from '../../../General/DeleteConfirmation';
import { FindFirstChild } from '../../../../utils/FindMenuOption';
import SuperSearchMultipleServer from '../../../shared/SuperSearch/MultipleSelection/SuperSearchMultipleServer';
import SuperSearchMultipleClient from '../../../shared/SuperSearch/MultipleSelection/SuperSearchMultipleClient';
import SuperSearchMultipleTest from '../../../shared/SuperSearch/MultipleSelection/SuperSearchMultipletesting';
import _, { set } from "lodash";

import Modal from 'react-bootstrap/Modal';
import Audit from '../../../General/Audit';
import ModalHeader from '../../../Setup/Shared/ModalHeader';
import { IconCopy, NoteIcon, NotesIcon } from '../../../shared/IconsComponent/icons';
import ModalFooter from '../../../Setup/Shared/ModalFooter';
import { useKeyboardShortcut } from '../../../../utils/useKeyboardShortcut';
import MergeDemographicsForm from '../../../shared/MergeIntakeForms/MergeDemographicsForm';
import SignEncounter from '../Encounter/Components/EncounterRightPortion/TemplateView/Components/SignEncounter';
////////
const Races = [
    {
        value: 'American Indian or Alaska Native', display: 'American Indian or Alaska Native',
        SubCategories: [
            { value: "Navajo Nation", display: 'Navajo Nation' },
            { value: "Cherokee", display: 'Cherokee' },
            { value: "Sioux", display: 'Sioux' },
            { value: "Chippewa", display: 'Chippewa' },
            { value: "Cherokee", display: 'Cherokee' },
            { value: "Apache", display: 'Apache' },
            { value: "Blackfeet", display: 'Blackfeet' },
            { value: "Iñupiat", display: 'Iñupiat' },
            { value: "Yup'ik", display: "Yup'ik" },
            { value: "Central American Indian", display: 'Central American Indian' },
            { value: "South American Indian", display: 'South American Indian' },
            { value: "Other American Indian tribes", display: 'Other American Indian tribes' },
        ]
    },
    {
        value: 'Asian', display: 'Asian',
        SubCategories: [
            { value: "Chinese", display: 'Chinese' },
            { value: "Filipino", display: 'Filipino' },
            { value: "Asian Indian", display: 'Asian Indian' },
            { value: "Vietnamese", display: 'Vietnamese' },
            { value: "Korean", display: 'Korean' },
            { value: "Japanese", display: 'Japanese' },
            { value: "Pakistani", display: 'Pakistani' },
            { value: "Thai", display: "Thai" },
            { value: "Cambodian", display: "Cambodian" },
            { value: "Hmong", display: "Hmong" },
            { value: "Laotian", display: "Laotian" },
            { value: "Other Asian", display: "Other Asian" },
        ]
    },
    {
        value: 'Black or African American', display: 'Black or African American',
        SubCategories: [
            { value: "African American", display: 'African American' },
            { value: "Jamaican", display: 'Jamaican' },
            { value: "Haitian", display: 'Haitian' },
            { value: "Nigerian", display: 'Nigerian' },
            { value: "Ethiopian", display: 'Ethiopian' },
            { value: "Somali", display: 'Somali' },
            { value: "Other African", display: 'Other African' },
            { value: "Afro-Caribbean", display: "Afro-Caribbean" },
        ]
    },
    {
        value: 'Native Hawaiian or Other Pacific Islander', display: 'Native Hawaiian or Other Pacific Islander',
        SubCategories: [
            { value: "Native Hawaiian", display: 'Native Hawaiian' },
            { value: "Samoan", display: 'Samoan' },
            { value: "Chamorro", display: 'Chamorro' },
            { value: "Tongan", display: 'Tongan' },
            { value: "Fijian", display: 'Fijian' },
            { value: "Marshallese", display: 'Marshallese' },
            { value: "Palauan", display: 'Palauan' },
            { value: "Tahitian", display: 'Tahitian' },
            { value: "Chuukese", display: 'Chuukese' },
            { value: "Other Pacific Islander", display: 'Other Pacific Islander' },

        ]
    },
    {
        value: 'White', display: 'White',
        SubCategories: [
            { value: "German", display: 'German' },
            { value: "Irish", display: 'Irish' },
            { value: "English", display: 'English' },
            { value: "Italian", display: 'Italian' },
            { value: "Polish", display: 'Polish' },
            { value: "French", display: 'French' },
            { value: "Iranian", display: 'Iranian' },
            { value: "Arab", display: 'Arab' },
            { value: "Other European", display: 'Other European' },
            { value: "Other Middle Eastern", display: 'Other Middle Eastern' },
            { value: "Other North African", display: 'Other North African' },

        ]
    },
    { value: 'Other', display: 'Other' },
    { value: 'Unknown', display: 'Unknown' },
    { value: 'Patient declines to specify', display: 'Patient declines to specify' },
];
const PrefixDropDown = [
    { value: "-1", display: "" },
    { value: "Mr", display: "Mr" },
    { value: "Mrs", display: "Mrs" },
    { value: "Ms", display: "Ms" },
    { value: "Dr", display: "Dr" },
    { value: "Capt", display: "Capt" },
    { value: "Prof", display: "Prof" },
    { value: "Col", display: "Col" },
]
const SuffixDropDown = [
    { value: "-1", display: "" },
    { value: "Jr", display: "Jr" },
    { value: "Sr", display: "Sr" },
    { value: "I", display: "I" },
    { value: "II", display: "II" },
    { value: "III", display: "III" },
    { value: "IV", display: "IV" },
]
const Ethnicity = [


    {
        value: 'Hispanic or Latino', display: 'Hispanic or Latino',
        SubCategories: [
            { value: "Mexican", display: 'Mexican' },
            { value: "Puerto Rican", display: 'Puerto Rican' },
            { value: "Cuban", display: 'Cuban' },
            { value: "Dominican", display: 'Dominican' },
            { value: "Salvadoran", display: 'Salvadoran' },
            { value: "Guatemalan", display: 'Guatemalan' },
            { value: "Colombian", display: 'Colombian' },
            { value: "Honduran", display: 'Honduran' },
            { value: "Ecuadorian", display: "Ecuadorian" },
            { value: "Peruvian", display: "Peruvian" },
            { value: "Venezuelan", display: "Venezuelan" },
            { value: "Panamanian", display: "Panamanian" },
            { value: "Nicaraguan", display: "Nicaraguan" },
            { value: "Chilean", display: "Chilean" },
            { value: "Argentine", display: "Argentine" },
            { value: "Other Central American", display: "Other Central American" },
            { value: "Other South American", display: "Other South American" },
            { value: "Other Hispanic or Latino", display: "Other Hispanic or Latino" },

        ]


    },
    { value: 'Not Hispanic or Latino', display: 'Not Hispanic or Latino' },
    { value: 'Other', display: 'Other' },
    { value: 'Unknown', display: 'Unknown' },
    { value: 'Patient declines to specify', display: 'Patient declines to specify' },

]

const Demographics = (props) => {
    const API_URL_Patient = enumUtil.controller.Patient
    const isLive = process.env.REACT_APP_ISLIVE
    let IsEditAllowed = FindFirstChild('Patient', 'Demographics')?.IsAdd
    const [isOpenMissing, setIsOpenMissing] = useState(false)
    const [missingData, setMissingData] = useState(false)
    const [missingDataInfo, setMissingDataInfo] = useState([])
    const [showPopup, setshowPopup] = useState(false);
    const [slectedInActiveData, setSlectedInActiveData] = useState({})
    const [isSign, setIsSign] = useState(false);
    const [imgFile, setImgFile] = useState(null);
    const [printoutModal, setPrintOutModal] = useState(false)
    const [isProviderActive, setIsProviderActive] = useState(false);
    let PateintIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));
    const PracticeID = useSelector(state => state?.GeneralDropDownsReducer?.Practice?.[0]?.PracticeID || null);
    PateintIDR = PateintIDR?.data?.id
    let reduxData = useSelector(state => state.Open_Patient_Tab)
    let PatientData = useSelector(state => state.PatientRecordReducer);
    let PatientPortalAccessRedux = useSelector(state => state.SettingsReducer?.PatientPortalAccess);

    let LOC_Modal = {
        PatientLOCID: "0",
        LOCFramework: "",
        LevelOfCare: "",
        StartDate: null,
        EndDate: null,
        AttendingProviderID: "",
        RenderingProviderID: "",
        Notes: "",
    };

    let LOCValidationModal = {
        LevelOfCareVal: "",
        StartDateVal: "",
        AttendingProviderVal: "",
    };
    const [mainLOCModal, setMainLOCModal] = useState(LOC_Modal);
    const [LOCSaveUpdateModal, setLOCSaveUpdateModal] = useState({});
    const [patientLOCHistory, setPatientLOCHistory] = useState([]);
    const [LOCValidationState, setLOCValidationState] = useState(LOCValidationModal);
    const [isSharing, setIsSharing] = useState(false);
    // const skipNextFocus = useRef(false);

    // let tabId =useSelector(state => state.Open_Patient_Tab.map((pt)=> pt.data.id));
    // console.log(tabId);
    // console.log('patientID', PateintIDR.data.id);
    let Patient_Modal = {
        CoOrdinatorName: "",
        MedicaidNo: '',
        MedicareNo: '',
        ProfilePicture: "",
        ShiftID: '',
        // ProfilePictureURL:"",
        AccountNumber: '',
        LastName: '',
        FirstName: '',
        Medicare: '',
        Medicaid: '',
        PreviousName: '',
        PreferredName: '',
        GenderIdentityNotes: '',
        SexualOrientationNotes: '',
        GenderIdentityNotes: '',
        SexualOrientationNotes: '',
        Prefix: '',
        Suffix: '',
        SSN: '',
        County: '',
        Neighborhood: '',
        Gender: '',
        MI: '',
        PA: [],
        MaritalStatus: '',
        DOB: null,
        CreatedDate: null,
        Age: '',
        AddressLine1: '',
        AddressLine2: '',
        City: '',
        State: '',
        ZipCode: '',
        HomePhoneNumber: '',
        MobileNumber: '',
        WorkNumber: '',
        WorkPhoneExtention: '',
        OtherPhoneNumber: '',
        Email: '',
        FaxNumber: '',
        LanguageProficiency: '',
        PreferredLanguage: '',
        PreferredCommunication: '',
        LocationID: '',
        RequestStartDate: '',
        CoOrdinatorID: '',
        PreferredCareGiverGender: '',
        LocationName: '',
        ProviderID: '',
        RefProviderID: '',
        PharmacyID: '',
        EmployerID: '',
        EmploymentStatus: '',
        StudentStatus: '',
        Class: '',
        Race: '',
        Ethnicity: '',
        Marketer: [],
        SmokingStatus: '',
        BirthCity: '',
        BirthOrder: '',
        GenderIdentity: '',
        SexualOrientation: '',
        DateOfDeath: null,
        CauseOfDeath: '',
        PatientReferralSource: '',
        BloodGroup: '',
        MotherFirstName: '',
        MotherMedianName: '',
        HispanicOrLatino: '',
        MaidenLastName: '',
        MultipleBirth: '',
        Pregnancy: '',
        IsDeceased: '',
        SignatureOnFile: '',
        ReleaseOfFile: '',
        Statuss: '',
        ErrorMessages: '',
        CreatedBy: '',
        CreatedDate: '',
        HoldSubmission: '',
        HoldStatement: '',
        ExcludeFromReporting: '',
        ExcludeFromReportingNotes: '',
        HoldSubmissionNotes: '',
        HoldStatementNotes: '',
    }
    let Patient_Admission_Modal = {
        PatientAdmissionStatusID: "0",
        AdmissionStatus: "",
        Date: "",
        Source: "",
        Notes: ""
    }
    let valModal = {}
    let ValidationModal = {
        FirstNameVal: "",
        FirstNameVal: "",
        LastNameVal: "",
        SSNLengthVal: "",
        ZipCodeLengthVal: "",
        HomePhoneNumberlen: "",
        MobileNumberlen: "",
        WorkNumberlen: "",
        WorkPhoneExtentionlen: "",
        OtherPhoneNumberlen: "",
        FaxNumberlen: "",
        EmailAddressVal: "",
        MIval: "",
        ZipCodeVal: "",
        SSNval: "",
        LocationVal: "",
        Providerval: "",
        GenderIdentityNotesVal: '',
        HoldSubmissionNotesval: '',

    }
    const [range, setRange] = useState([
        {
            startDate: null,
            endDate: addDays(new Date(), 7),
            // endDate: null,
            key: 'selection'
        }
    ])
    const { mainClaimModal, handlePateintChange, handleClaimsChange, patientBody, handleSelectedClaimInfoData,
        ClaimInfoVal, isReadOnly, ProviderID, RefProviderID, POScode, BillingProviderID, handleSelectRecentPateint } = { ...props }
    const [isLoading, setIsLoading] = useState(false)
    const [PatientValidationModal, setPatientValidationModal] = useState(ValidationModal)
    const [PatientID, setPatientID] = useState()
    const [PatientAmissionID, setPatientAmissionID] = useState('0')
    const [patientadmission, setpatientadmission] = useState([])
    const [PatientSaveUpdateModal, setPatientSaveUpdateModal] = useState({})
    const [PatientAdmissionSaveUpdateModal, setPatientAdmissionSaveUpdateModal] = useState({})
    const API_URL = enumUtil.controller.PATIENT
    const API_URL_Wasabi = enumUtil.controller.Wasabi
    const API_URL_CH = enumUtil.controller.EDI
    const API_URL_GENERAL = enumUtil.controller.General
    const PatPortalLogin = enumUtil.controller.PatientPortalLogin
    const [mainPatientModal, setmainPatientModal] = useState(Patient_Modal);
    const [mainPatientAdmissionmodal, setmainPatientAdmissionmodal] = useState(Patient_Admission_Modal);
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    const isHomeCareCheck = DropDowns.IsHomeCare
    const [newPatientSaved, setNewPatientSaved] = useState(false);
    const [is, setIs] = useState(true);
    const [race, setRace] = useState([])
    const [ethnicity, setEthnicity] = useState([])
    const [SuperListPA, setSuperListPA] = useState([])
    const [Marketerr, setMarketerr] = useState([])
    const [expanded, setExpanded] = useState('Pateint1-content');
    const [LocationID, setLocationID] = useState('LocationID');
    const [locationID, setlocationID] = useState('');
    const [providerID, setProviderID] = useState('');
    const [RefproviderID, setRefProviderID] = useState('');
    const [id, setID] = useState();
    const [isOpenDelete, setIsOpenDelete] = useState(false)
    const [isclose, setIsclose] = useState();
    const [mainpicmodel, setMainpicmodel] = useState();
    const [genderClass, setGenderClass] = useState('');
    const [selectedDataDisplay, setselectedDataDisplay] = useState('')
    const [CountyList, setCountyList] = useState([])
    const [countyDropdown, setcountyDropdown] = useState('');
    const [itemToDelete, setItemToDelete] = useState(null);
    const [ShiftD, setShiftID] = useState()
    const [ShifDD, setShiftDD] = useState({})


    const API_URL_County = enumUtil.controller.ProviderFeeSchedule
    const [cptBody, setcptBody] = useState({ "TableName": enumUtil.enumAPITableName.CareGiver, "SearchParam": '' })
    let dispatch = useDispatch();
    let ShiftOption = []
    const handleShiftDropdown = () => {
        setIsLoading(true)
        ServerRequestProtected(API_URL_GENERAL + "/DropDown", 'post', {
            "TableName": enumUtil.enumAPITableName.Shifts
        }).then((response) => {
            setIsLoading(false)
            setShiftDD(response)
            ShiftOption = response;
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            setIsLoading(false)
        })
    }
    useEffect(() => {
        handleShiftDropdown()
    }, []);

    const LoaduserImage = async (imgURL) => {
        // setIsLoading(true)
        try {
            const response = await ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
                "BucketPath": imgURL,
            }, "Download")

            if (response.type === 'application/jpg') {
                const blob = response
                const objectURL = URL.createObjectURL(blob);
                console.log('objectURL', objectURL);
                return objectURL
                // setmainPatientModal({ ...mainPatientModal, ProfilePicture: objectURL })
            }
            // setIsLoading(false)

        } catch (error) {
            // setIsLoading(false);
            throw error;
        }
    }
    const LoadDemographics = async () => {
        // setIs(fsldr)
        if (PatientID === 0) {
            setmainPatientModal({
                ...mainPatientModal,
                LocationID: DropDowns?.Location.length === 2 ? DropDowns?.Location[1].display : '',
                ProviderID: DropDowns?.Provider.length === 2 ? DropDowns?.Provider?.[1].Active === 'false' ? "" : DropDowns?.Provider[1].display : '',
                Statuss: true
            })
            setPatientSaveUpdateModal({
                ...PatientSaveUpdateModal,
                LocationID: DropDowns?.Location.length === 2 ? DropDowns?.Location[1].value + "" : '-1',
                ProviderID: DropDowns?.Provider.length === 2 ? DropDowns?.Provider?.[1].Active === 'false' ? "" : DropDowns?.Provider[1].value + "" : '-1',
                Statuss: "true"
            })

        }
        ////Updating Opened Patient Id///
        if (PateintIDR === -1) {
            if (!newPatientSaved) { setPatientID(0) }
        } else { setPatientID(PateintIDR) }
        //////
        setIsLoading(false)
        if (!isNull(PatientID)) {
            setIsLoading(true)
            // setIsLoading(true)
            await handleShiftDropdown()
            ServerRequestProtected(API_URL + "/FindListByID", 'post', {
                "ID": PatientID,
                "TableName": enumUtil.enumAPITableName.Patient
            }).then(async (response) => {
                const profilePicturePath = response.ProfilePicture;
                // setcountyDropdown(response.State)
                if (!isNull(response.State) && !isNull(response.City)) {
                    GetPatCounty(response.State, response.City);
                }
                setlocationID(response.LocationID)
                setProviderID(response.ProviderID)
                setRefProviderID(response.RefProviderID)
                response.State = DropdownValueHandler(States, response.State)
                response.LocationID = DropdownValueHandler(DropDowns?.Location, response.LocationID)
                response.ShiftID = DropdownValueHandler(ShiftOption, response.ShiftID)
                response.ProviderID = DropdownValueHandler(DropDowns?.Provider, response.ProviderID)
                response.RefProviderID = DropdownValueHandler(DropDowns?.RefProvider, response.RefProviderID)
                response.CoOrdinatorID = DropdownValueHandler(DropDowns?.CoOrdinator, response.CoOrdinatorID)
                // const patientAdmissionList = response.List;
                setpatientadmission(response.List)
                setPatientLOCHistory(response.LOCList || []);
                if (!isNull(response.MobileNumber)) {
                    response.MobileNumber = FormatPhoneNumber(response.MobileNumber)
                }
                if (!isNull(response.WorkNumber)) {
                    response.WorkNumber = FormatPhoneNumber(response.WorkNumber)
                }
                if (!isNull(response.OtherPhoneNumber)) {
                    response.OtherPhoneNumber = FormatPhoneNumber(response.OtherPhoneNumber)
                }
                if (!isNull(response.HomePhoneNumber)) {
                    response.HomePhoneNumber = FormatPhoneNumber(response.HomePhoneNumber)
                }
                GenderDemographic.filter((type) => {
                    if (type.value === response.Gender) {
                        response.Gender = type.display
                    }
                })
                PrefixDropDown.filter((type) => {
                    if (type.value === response.Prefix) {
                        response.Prefix = type.display
                    }
                })
                SuffixDropDown.filter((type) => {
                    if (type.value === response.Suffix) {
                        response.Suffix = type.display
                    }
                })
                BloodGroup.filter((type) => {
                    if (type.value === response.BloodGroup) {
                        response.BloodGroup = type.display
                    }
                })
                SexualOrientation.filter((type) => {
                    if (type.value === response.SexualOrientation) {
                        response.SexualOrientation = type.display
                    }
                })
                BirthOrder.filter((type) => {
                    if (type.value === response.BirthOrder) {
                        response.BirthOrder = type.display
                    }
                })
                LanguageProficiencyDropdown.filter((type) => {
                    if (type.value === response.LanguageProficiency) {
                        response.LanguageProficiency = type.display
                    }
                })
                PreferredLanguage.filter((type) => {
                    if (type.value === response.PreferredLanguage) {
                        response.PreferredLanguage = type.display
                    }
                })
                PreferredCommunication.filter((type) => {
                    if (type.value === response.PreferredCommunication) {
                        response.PreferredCommunication = type.display
                    }
                })

                // GenderIdentity.filter((type) => {
                //     if (type.value === response.GenderIdentity) {
                //         response.GenderIdentity = type.display
                //     }
                // })
                response.GenderIdentity = DropdownValueHandler(GenderIdentity, response.GenderIdentity)

                // MaritalStatus.filter((type) => {
                //     if (type.value === response.MaritalStatus) {
                //         response.MaritalStatus = type.display
                //     }
                // })

                response.MaritalStatus = DropdownValueHandler(MaritalStatus, response.MaritalStatus)

                EmploymentStatus.filter((type) => {
                    if (type.value === response.EmploymentStatus) {
                        response.EmploymentStatus = type.display
                    }
                })
                StudentStatus.filter((type) => {
                    if (type.value === response.StudentStatus) {
                        response.StudentStatus = type.display
                    }
                })
                response.EmploymentStatus = response.EmploymentStatus.toString();
                response.StudentStatus = response.StudentStatus.toString();
                EmploymentStatus.forEach((type) => {
                    if (type.value.toString() === response.EmploymentStatus) {
                        response.EmploymentStatus = type.display;
                    }
                });
                StudentStatus.forEach((type) => {
                    if (type.value.toString() === response.StudentStatus) {
                        response.StudentStatus = type.display;
                    }
                })
                setmainPatientModal({
                    ...response, DOB: !isNull(response.DOB) ? FormatDate(response.DOB) : null,
                    DateOfDeath: !isNull(response.DateOfDeath) ? FormatDate(response.DateOfDeath) : null
                })
                if (response.SignaturePath) {
                    ViewFile(response.SignaturePath);
                }
                if (response.Gender === 'Male') {
                    setGenderClass('za-male');
                } else if (response.Gender === 'Female') {
                    setGenderClass('za-female');
                }
                else {
                    setGenderClass('za-others');
                }
                // setMainpicmodel(response.ProfilePicture)
                setMainpicmodel(response.ProfilePicture)
                let racee = !isNull(response.Race) ? response.Race.split(',') : ''
                let racearr = []
                if (racee.length > 0) {
                    racee.map((item) => {
                        racearr.push({ value: item, display: item })
                    })
                }
                let eth = !isNull(response.Ethnicity) ? response.Ethnicity.split(',') : ''
                let ethar = [];
                if (eth.length > 0) {
                    eth.map((item) => {
                        ethar.push({ value: item, display: item })
                    })
                }
                // let Paa = !isNull(response.PA) ? response.PA.split(', ') : ''
                // let PAA = [];
                // if (Paa.length > 0) {
                //     Paa.map((item) => {
                //         PAA.push({ value: item, display: item })
                //     })
                // }
                // let Mark = !isNull(response.Marketer) ? response.Marketer.split(', ') : ''
                // let Market = [];
                // if (Mark.length > 0) {
                //     Mark.map((item) => {
                //         Market.push({ value: item, display: item })
                //     })
                // }
                if (!isNull(response.ErrorMessages)) {
                    let splitedData = response.ErrorMessages.split(';')
                    setMissingDataInfo(splitedData)
                }

                setRace(racearr)
                setEthnicity(ethar)
                // if (profilePicturePath) {
                //     LoaduserImage(profilePicturePath)
                //         .then((imgURL) => {
                //             setmainPatientModal((prev) => ({
                //                 ...prev,
                //                 ProfilePicture: imgURL
                //             }));
                //             setMainpicmodel(imgURL);
                //         })
                //         .catch((err) => {
                //             console.log("Profile pic load failed: ", err);
                //         });
                // }
                setInitialState(response);

                // setSuperListPA(PAA)
                // setMarketerr(Market)
                setIsLoading(false)
            }).catch((error) => {
                NotificationHandler(error.message, enumUtil.enumtoaster.error)
                setIsLoading(false)
            })
        }
    }

    useEffect(() => {
        if (PatientID && PatientID > 0) {
            LoadDemographics();
        }
    }, [PatientID]);

    useEffect(() => {
        setlocationID(locationID)
        setProviderID(ProviderID)
        setRefProviderID(RefProviderID)

        LoadDemographics()
    }, [PatientID])
    useEffect(() => {
        setlocationID(locationID)
        setProviderID(ProviderID)
        setRefProviderID(RefProviderID)
        if (!isNull(props.Reload)) {
            let data = props.id
            data.map((item) => {
                if (item.key === 212) {
                    LoadDemographics()
                }
            })
        }
    }, [props.Reload, LocationID, ProviderID, RefProviderID, isclose])
    const handleChangeAccodian = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
        if (!isExpanded && panel === 'other') {
            setExpanded('Pateint1-content');
        }
        if (!isExpanded && panel === 'Pateint1-content') {
            setExpanded('other');
        }
    };
    const PatientValidation = async () => {
        let faxNumber = "";
        let OtherPhonenumber = "";
        let HomeNmber = "";
        let MobileContact = "";
        let Workcontact = "";
        if (!isNull(mainPatientModal.FaxNumber)) {
            faxNumber = mainPatientModal.FaxNumber.replace(/-/g, "");
        }
        if (!isNull(mainPatientModal.OtherPhoneNumber)) {
            OtherPhonenumber = mainPatientModal.OtherPhoneNumber.replace(/[()-\s]/g, '');
        }
        if (!isNull(mainPatientModal.HomePhoneNumber)) {
            HomeNmber = mainPatientModal.HomePhoneNumber.replace(/[()-\s]/g, '');
        }
        if (!isNull(mainPatientModal.MobileNumber)) {
            MobileContact = mainPatientModal.MobileNumber.replace(/[()-\s]/g, '');
        }
        if (!isNull(mainPatientModal.WorkNumber)) {
            Workcontact = mainPatientModal.WorkNumber.replace(/[()-\s]/g, '');
        }
        let ValidationModal = {
            FirstNameVal: FormValidator(
                mainPatientModal.FirstName,
                enumUtil.enumValidationType.Required,
                'First Name',
            ),
            LastNameVal: FormValidator(
                mainPatientModal.LastName,
                enumUtil.enumValidationType.Required,
                'Last Name',
            ),
            GenderVal: FormValidator(
                mainPatientModal.Gender,
                enumUtil.enumValidationType.Required,
                'Gender',
            ),
            LocationVal: FormValidator(
                mainPatientModal.LocationID,
                enumUtil.enumValidationType.Required,
                'Location',
            ),

            DOBVal: FormValidator(
                mainPatientModal.DOB,
                enumUtil.enumValidationType.Required,
                'DOB',
            ),
            SSNLengthVal: FormValidator(
                mainPatientModal.SSN,
                enumUtil.enumValidationType.Length,
                'SSN',
                9
            ),
            ZipCodeLengthVal: FormValidator(
                mainPatientModal.ZipCode,
                enumUtil.enumValidationType.Lengths,
                'Zip Code',
                5, 9
            ),
            HomePhoneNumberlen: FormValidator(
                HomeNmber,
                enumUtil.enumValidationType.Length,
                'Home Number',
                10
            ),
            MobileNumberlen: FormValidator(
                MobileContact,
                enumUtil.enumValidationType.Length,
                'Mobile Number',
                10
            ),
            WorkPhoneExtentionlen: FormValidator(
                mainPatientModal.WorkPhoneExtention,
                enumUtil.enumValidationType.Length,
                'Work Extension',
                4
            ),
            OtherPhoneNumberlen: FormValidator(
                OtherPhonenumber,
                enumUtil.enumValidationType.Length,
                'Other Number',
                10
            ),
            FaxNumberlen: FormValidator(
                faxNumber,
                enumUtil.enumValidationType.Length,
                'Fax Number',
                10
            ),
            EmailAddressVal: FormValidator(
                mainPatientModal.Email,
                enumUtil.enumValidationType.Email,
                'Email',
            ),
            WorkNumberlen: FormValidator(
                Workcontact,
                enumUtil.enumValidationType.Length,
                'Work Number',
                10
            ),
            ZipCodeVal: FormValidator(
                mainPatientModal.ZipCode,
                enumUtil.enumValidationType.Digit,
                'Zip Code'
            ),
            MIval: FormValidator(
                mainPatientModal.MI,
                enumUtil.enumValidationType.Alphabet,
                'MI'
            ),
            // GenderIdentityNotesVal: FormValidator(
            //     mainPatientModal.GenderIdentityNotes,
            //     enumUtil.enumValidationType.Required,
            //     'Notes'
            // ),


            Providerval: isHomeCareCheck === "true" ? null :
                FormValidator(
                    mainPatientModal.ProviderID,
                    enumUtil.enumValidationType.Required,
                    'Provider',
                ),
            HoldSubmissionNotesval: mainPatientModal?.HoldSubmission === "true" || mainPatientModal?.HoldSubmission === true ? FormValidator(
                mainPatientModal.HoldSubmissionNotes,
                enumUtil.enumValidationType.Required,
                'Hold Submission Notes',
            ) : null,
            HoldStatementNotesval: mainPatientModal?.HoldStatement === "true" || mainPatientModal?.HoldStatement === true ? FormValidator(
                mainPatientModal.HoldStatementNotes,
                enumUtil.enumValidationType.Required,
                'Hold Statement Notes',
            ) : null,


        }
        await setPatientValidationModal(ValidationModal)
        valModal = ValidationModal

    }
    const handlePatientChange = (e) => {
        setIs(false);
        let { name, value, checked, type } = e.target;

        let modal = { ...mainPatientModal };
        let saveModal = { ...PatientSaveUpdateModal };

        if (name === "MultipleBirth" || name === 'Pregnancy' || name === 'IsDeceased' || name === 'SignatureOnFile' || name === 'ReleaseOfFile' || name === 'Statuss' || name === 'ExcludeFromReporting' || name === 'HoldSubmission' || name === 'HoldStatement') {
            modal[name] = !modal[name]
        } else if (['MobileNumber', 'WorkNumber', 'OtherPhoneNumber', 'HomePhoneNumber'].includes(name)) {
            const formattedValue = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            modal[name] = !formattedValue[2] ? formattedValue[1] : `(${formattedValue[1]}) ${formattedValue[2]}${formattedValue[3] ? '-' + formattedValue[3] : ''}`;
        } else if (name === 'ZipCode') {
            modal[name] = value;
            if (value.length === 9 || value.length === 5) {
                const firstFive = value.substring(0, 5);
                GetZipCode(firstFive)
                    .then(data => {
                        GetPatCounty(data.save.State, data.save.City);
                        setmainPatientModal(prevState => ({ ...prevState, ...data?.main }));
                        setPatientSaveUpdateModal(prevState => ({ ...prevState, ...data?.save }));
                    })
                    .catch(error => {
                        console.error("Zip code fetch error:", error);
                    });
            }
        } else {
            modal[name] = value;
        }

        setmainPatientModal(modal);

        for (var property in Patient_Modal) {
            if (name === property) {
                if (name === "MultipleBirth" || name === 'Pregnancy' || name === 'IsDeceased' || name === 'SignatureOnFile' || name === 'ReleaseOfFile' || name === 'Statuss' || name === 'ExcludeFromReporting' || name === 'HoldSubmission' || name === 'HoldStatement') {
                    saveModal[name] = modal[name] + ""
                } else {
                    saveModal[name] = value
                }
            }
        }
        setPatientSaveUpdateModal(saveModal)


    };

    // Handle input changes for LOC form
    const handleLOCChange = (e) => {
        setIs(false);
        let { name, value } = e.target;

        let modal = { ...mainLOCModal };
        let saveModal = { ...LOCSaveUpdateModal };

        modal[name] = value;
        setMainLOCModal(modal);

        for (var property in LOC_Modal) {
            if (name === property) {
                saveModal[name] = value;
            }
        }
        setLOCSaveUpdateModal(saveModal);
    };

    // Handle LOC Framework selection (resets Level of Care)
    const handleLOCFrameworkChange = (selectedData, name, type) => {
        let modal = { ...mainLOCModal };
        let saveModal = { ...LOCSaveUpdateModal };

        if (type === 'client' && !isNull(selectedData)) {
            modal[name] = selectedData.display;
            saveModal[name] = selectedData.value + "";

            // Reset Level of Care when framework changes
            modal.LevelOfCare = "";
            saveModal.LevelOfCare = "";

            setMainLOCModal(modal);
            setLOCSaveUpdateModal(saveModal);
        } else {
            modal[name] = '';
            saveModal[name] = '';
            setMainLOCModal(modal);
            setLOCSaveUpdateModal(saveModal);
        }
    };

    // Handle Level of Care selection
    const handleLOCLevelChange = (selectedData, name, type) => {
        let modal = { ...mainLOCModal };
        let saveModal = { ...LOCSaveUpdateModal };

        if (type === 'client' && !isNull(selectedData)) {
            modal[name] = selectedData.display;
            saveModal[name] = selectedData.value + "";
            setMainLOCModal(modal);
            setLOCSaveUpdateModal(saveModal);
        } else {
            modal[name] = '';
            saveModal[name] = '';
            setMainLOCModal(modal);
            setLOCSaveUpdateModal(saveModal);
        }
    };

    // Handle date changes (Start & End dates)
    const handleLOCDateChange = (date, type) => {
        let modal = { ...mainLOCModal };
        let saveModal = { ...LOCSaveUpdateModal };

        modal[type] = date;
        saveModal[type] = date;

        setMainLOCModal(modal);
        setLOCSaveUpdateModal(saveModal);
    };

    // Handle provider selection
    const handleLOCProviderChange = (selectedData, name, type) => {
        let modal = { ...mainLOCModal };
        let saveModal = { ...LOCSaveUpdateModal };

        if (type === 'client' && !isNull(selectedData)) {
            modal[name] = selectedData.display;
            saveModal[name] = selectedData.value + "";
            setMainLOCModal(modal);
            setLOCSaveUpdateModal(saveModal);
        } else {
            modal[name] = '';
            saveModal[name] = '';
            setMainLOCModal(modal);
            setLOCSaveUpdateModal(saveModal);
        }
    };

    const framework = LOCSaveUpdateModal.LOCFramework;

    const isFrameworkSelected = framework && framework !== '' && framework !== '-1';

    const validateLOC = () => {

        let validationErrors = {
            LevelOfCareVal: isFrameworkSelected
                ? FormValidator(
                    LOCSaveUpdateModal.LevelOfCare,
                    enumUtil.enumValidationType.Required,
                    'Level of Care'
                )
                : null,
            StartDateVal: isFrameworkSelected
                ? FormValidator(
                    LOCSaveUpdateModal.StartDate,
                    enumUtil.enumValidationType.Required,
                    'Start Date'
                )
                : null,
            AttendingProviderVal: isFrameworkSelected
                ? FormValidator(
                    LOCSaveUpdateModal.AttendingProviderID,
                    enumUtil.enumValidationType.Required,
                    'Attending Provider'
                )
                : null,
        };

        setLOCValidationState(validationErrors);
        return validationErrors;
    };

    const handleEditLOC = (item) => {
        setMainLOCModal({
            PatientLOCID: item.PatientLOCID + "",
            LOCFramework: item.LOCFramework,
            LevelOfCare: item.LevelOfCare,
            StartDate: item.StartDate,
            EndDate: item.EndDate,
            AttendingProviderID: item.AttendingProviderID,
            RenderingProviderID: item.RenderingProviderID,
            Notes: item.Notes,
        });
        setLOCSaveUpdateModal({
            LOCFramework: item.LOCFramework,
            LevelOfCare: item.LevelOfCare,
            StartDate: item.StartDate,
            EndDate: item.EndDate,
            AttendingProviderID: item.AttendingProviderID,
            RenderingProviderID: item.RenderingProviderID,
            Notes: item.Notes,
        });
    };

    const getLevelOfCareOptions = () => {
        const framework = mainLOCModal.LOCFramework;

        if (framework.includes("ASAM")) {
            return ASAMLevelOfCareDropdown;
        } else if (framework.includes("LOCUS")) {
            return LOCUSLevelOfCareDropdown;
        }
        return [];
    };

    const handleChangeDD = (e) => {
        setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainPatientModal };
        let saveModal = { ...PatientSaveUpdateModal }
        modal[name] = value
        setmainPatientModal(modal)
        for (var property in Patient_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setPatientSaveUpdateModal(saveModal)
    }

    const handleChangePatientAdmission = (e) => {
        setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainPatientAdmissionmodal };
        let saveModal = { ...PatientAdmissionSaveUpdateModal }
        modal[name] = value
        setmainPatientAdmissionmodal(modal)
        for (var property in Patient_Admission_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setPatientAdmissionSaveUpdateModal(saveModal)
    }
    const handleCancelDocument = () => {
        setPatientAmissionID('0')
        setmainPatientAdmissionmodal(Patient_Admission_Modal)
        // removeFile();
        setPatientAdmissionSaveUpdateModal({})
        // setfile(null)
        // onCancel();
    }
    const handleSavePatient = async () => {
        if (IsEditAllowed) {
            await PatientValidation()
            let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)

            if (validation) {
                NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
                return
            } else {
                // Format phone numbers (your existing code)
                if (!isNull(PatientSaveUpdateModal.FaxNumber)) {
                    PatientSaveUpdateModal['FaxNumber'] = PatientSaveUpdateModal.FaxNumber.replace(/-/g, "");
                }
                if (!isNull(PatientSaveUpdateModal.MobileNumber)) {
                    PatientSaveUpdateModal['MobileNumber'] = PatientSaveUpdateModal.MobileNumber.replace(/[()-\s]/g, "");
                    PatientSaveUpdateModal.MobileNumber = PatientSaveUpdateModal.MobileNumber.slice(0, 10);
                }
                if (!isNull(PatientSaveUpdateModal.WorkNumber)) {
                    PatientSaveUpdateModal['WorkNumber'] = PatientSaveUpdateModal.WorkNumber.replace(/[()-\s]/g, "");
                    PatientSaveUpdateModal.WorkNumber = PatientSaveUpdateModal.WorkNumber.slice(0, 10);
                }
                if (!isNull(PatientSaveUpdateModal.OtherPhoneNumber)) {
                    PatientSaveUpdateModal['OtherPhoneNumber'] = PatientSaveUpdateModal.OtherPhoneNumber.replace(/[()-\s]/g, "");
                    PatientSaveUpdateModal.OtherPhoneNumber = PatientSaveUpdateModal.OtherPhoneNumber.slice(0, 10);
                }
                if (!isNull(PatientSaveUpdateModal.HomePhoneNumber)) {
                    PatientSaveUpdateModal['HomePhoneNumber'] = PatientSaveUpdateModal.HomePhoneNumber.replace(/[()-\s]/g, "");
                    PatientSaveUpdateModal.HomePhoneNumber = PatientSaveUpdateModal.HomePhoneNumber.slice(0, 10);
                }

                const isEmptyObject = (obj) => {
                    return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
                };

                // Prepare OtherData object
                let otherData = {};

                // Add Admission data if present
                if (!isNull(PatientAdmissionSaveUpdateModal) && !isEmptyObject(PatientAdmissionSaveUpdateModal)) {
                    otherData = {
                        ...PatientAdmissionSaveUpdateModal,
                        PatientAdmissionStatusID: mainPatientAdmissionmodal.PatientAdmissionStatusID
                    };
                }

                // Add LOC data directly to OtherData (like Admission)

                let otherDetails = null;

                const hasLOCData = LOCSaveUpdateModal.LOCFramework || LOCSaveUpdateModal.LevelOfCare;
                if (hasLOCData) {
                    const locErrors = validateLOC();
                    const locValidation = FormValidator([locErrors], enumUtil.enumValidationType.NullCheck);

                    if (locValidation) {
                        NotificationHandler('Please fill required LOC fields', enumUtil.enumtoaster.error);
                        return;
                    }


                    otherDetails = {
                        PatientLevelOfCareID: mainLOCModal.PatientLOCID || "0",
                        PatientID: PatientID || "",
                        LOCFramework: LOCSaveUpdateModal.LOCFramework,
                        LevelOfCare: LOCSaveUpdateModal.LevelOfCare,
                        StartDate: LOCSaveUpdateModal.StartDate,
                        EndDate: LOCSaveUpdateModal.EndDate || null,
                        AttendingProviderID: LOCSaveUpdateModal.AttendingProviderID,
                        RenderingProviderID: LOCSaveUpdateModal.RenderingProviderID,
                        LOCNotes: LOCSaveUpdateModal.Notes,
                    };
                }

                let saveModal = {
                    TableName: enumUtil.enumAPITableName.Patient,
                    ID: PatientID + "",
                    data: { ...PatientSaveUpdateModal },
                    OtherData: otherData,
                    OtherDetails: otherDetails,
                    value: null
                };


                setIsLoading(true);

                ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                    .then((response) => {
                        if (!isNull(response.id)) {
                            setIsLoading(false);
                            setGenderotesPopup(false);
                            setNotesPopup(false);
                            NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success);
                            setNewPatientSaved(true);
                            setPatientID(response.id - "");
                            setPatientAmissionID(response.id);
                            handleMissingData(response.id);
                            handleCancelDocument();

                            // Reset LOC form after successful save
                            if (hasLOCData) {
                                setMainLOCModal(LOC_Modal);
                                setLOCSaveUpdateModal({});
                                setLOCValidationState(LOCValidationModal);
                                LoadDemographics();// Refresh LOC history table
                            }

                            if (PateintIDR === -1) {
                                // Your existing new patient logic
                                let newItem = { ID: response.id, name: PatientSaveUpdateModal.FirstName, FullName: PatientSaveUpdateModal.FirstName + ', ' + PatientSaveUpdateModal.LastName + ', ', AccountNumber: PatientSaveUpdateModal.AccountNumber ? PatientSaveUpdateModal.AccountNumber : '' };
                                let data = [...PatientData, newItem];
                                dispatch(PatientRecordAction(data));
                                let obj = {
                                    key: 2,
                                    name: "Patient",
                                    active: true,
                                    data: {
                                        id: response.id,
                                        name: PatientSaveUpdateModal.FirstName,
                                        newPatient: true
                                    },
                                };
                                let updatedData = reduxData.map((item, index) => {
                                    if (item.data.id === -1 && PateintIDR === -1) {
                                        return item = obj;
                                    } else {
                                        return item;
                                    }
                                });
                                let DD = {
                                    ...DropDowns, DisCardActiveIds: {
                                        ...DropDowns.DisCardActiveIds,
                                        Patient: DropDowns.DisCardActiveIds.Patient.map(item =>
                                            item.PatientID === -1
                                                ? {
                                                    ...item,
                                                    isDemographicsOpened: true,
                                                    isDemographicsUpdated: false,
                                                    isInsuranceOpened: false,
                                                    isInsuranceUpdated: false,
                                                    PatientID: response.id
                                                }
                                                : item
                                        )
                                    }
                                };
                                dispatch(GeneralDropDowns(DD));
                                dispatch(OpenNewPatientTabAction(updatedData));
                            }
                        }
                    })
                    .catch((error) => {
                        setIsLoading(false);
                        NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
                    });
            }
        }
    }
    const handleRangeChange = (date) => {
        mainPatientModal.DOB = format(date[0].startDate, 'yyyy/MM/dd') + ' to ' + format(date[0].endDate, 'yyyy/MM/dd')
        PatientSaveUpdateModal['DOB'] = mainPatientModal.DOB
        setRange(date)
        // setShowCalendar(false)
    }
    const calculateAge = (date) => {
        const birthDate = new Date(date)
        const currentDate = new Date();
        let years = currentDate.getFullYear() - birthDate.getFullYear();
        let months = currentDate.getMonth() - birthDate.getMonth();
        if (months < 0) {
            years = years - 1
            months = months + 12
        }
        if (!isNaN(years) && !isNaN(months)) {
            return years + ' years and ' + months + ' months';
        } else {
            return '';
        }
    };
    const handleCalendarChange = (date, type) => {
        var FormatedDate = date
        let modal = { ...mainPatientModal };
        let saveModal = { ...PatientSaveUpdateModal }
        modal[type] = FormatedDate
        if (type === 'DOB') {
            modal['Age'] = calculateAge(date)
        }
        setmainPatientModal(modal)
        for (var property in Patient_Modal) {
            if (type === property) {
                saveModal[type] = FormatedDate
            }
        }
        setPatientSaveUpdateModal(saveModal)
    }
    const handleCalendarChangeadmission = (date, type) => {
        var FormatedDate = date
        let modal = { ...mainPatientAdmissionmodal };
        let saveModal = { ...PatientAdmissionSaveUpdateModal }
        modal[type] = FormatedDate
        setmainPatientAdmissionmodal(modal)
        for (var property in Patient_Admission_Modal) {
            if (type === property) {
                saveModal[type] = FormatedDate
            }
        }
        setPatientAdmissionSaveUpdateModal(saveModal)
    }
    const handlePatientProfileChange = (e) => {
        const Type = e.target.files[0].type.substring(0, 5);
        if (Type === 'image') {
            let file = e.target.files[0]
            let reader = new FileReader();
            reader.onloadend = () => {
                let value = reader.result.toString();
                setmainPatientModal({ ...mainPatientModal, ProfilePicture: value })
                setPatientSaveUpdateModal({ ...PatientSaveUpdateModal, ProfilePicture: value })
            }
            reader.readAsDataURL(file);
        }

    }
    // const handlePatientProfileChange = (e) => {
    //     const Type = e.target.files[0].type.substring(0, 5);
    //     if (Type === 'image') {
    //         let file = e.target.files[0]
    //         let reader = new FileReader();

    //         reader.onloadend = () => {
    //             let value = reader.result.toString();
    //             let { name } = e.target;
    //             let modal = { ...mainPatientModal };
    //             let saveModal = { ...PatientSaveUpdateModal }
    //             modal[name] = value
    //             setmainPatientModal(modal)
    //             for (var property in Patient_Modal) {
    //                 if (name === property) {
    //                     saveModal[name] = value
    //                 }
    //             }
    //             setPatientSaveUpdateModal(saveModal)
    //         }
    //         reader.readAsDataURL(file);
    //     }
    // }
    const handleSelectedCooData = (selectedData, name, type) => {
        let modal = { ...mainPatientModal };
        if (type === 'client' && !isNull(selectedData)) {
            if (name === 'CoOrdinatorID') {

                modal[name] = selectedData.display
                PatientSaveUpdateModal[name] = selectedData.value + "";
            }
        } else {
            modal[name] = ''
            PatientSaveUpdateModal[name] = ''
        }
        return selectedData
    }
    // const handleSelectedData = (selectedData, name, type, mode) => {
    //     let modal = { ...mainPatientModal };
    //     if (type === 'client' && !isNull(selectedData)) {
    //         if (name === 'Gender') {
    //             modal[name] = selectedData.display
    //             PatientSaveUpdateModal[name] = selectedData.value + "";
    //         }
    //         if (name === 'MaritalStatus') {
    //             modal[name] = selectedData.display
    //             PatientSaveUpdateModal[name] = selectedData.value + "";
    //         }
    //         if (name === 'PreferredCareGiverGender') {
    //             modal[name] = selectedData.display
    //             PatientSaveUpdateModal[name] = selectedData.value + "";
    //         }
    //         if (name === 'EmploymentStatus') {
    //             modal[name] = selectedData.display
    //             PatientSaveUpdateModal[name] = selectedData.value + "";
    //         }
    //         if (name === 'StudentStatus') {
    //             modal[name] = selectedData.display
    //             PatientSaveUpdateModal[name] = selectedData.value + "";
    //         }
    //         if (name === 'Class') {
    //             modal[name] = selectedData.display
    //             PatientSaveUpdateModal[name] = selectedData.value + "";
    //         }
    //         if (name === 'BirthOrder') {
    //             modal[name] = selectedData.display
    //             PatientSaveUpdateModal[name] = selectedData.value + "";
    //         }
    //         if (name === 'GenderIdentity') {
    //             modal[name] = selectedData.display
    //             PatientSaveUpdateModal[name] = selectedData.value + "";
    //         }
    //         if (name === 'SexualOrientation') {
    //             modal[name] = selectedData.display
    //             PatientSaveUpdateModal[name] = selectedData.value + "";
    //         }
    //         if (name === 'BloodGroup') {
    //             modal[name] = selectedData.display
    //             PatientSaveUpdateModal[name] = selectedData.value + "";
    //         }
    //         // }
    //         // else if (name === 'LocationID') {
    //         // modal[name] = selectedData.display
    //         // PatientSaveUpdateModal[name] = selectedData.value + "";
    //         // }
    //         // else if (name === 'ProviderID') {
    //         // modal[name] = selectedData.display
    //         // PatientSaveUpdateModal[name] = selectedData.value + "";
    //         // }
    //         // else if (name === 'RefProviderID') {
    //         // modal[name] = selectedData.display
    //         // PatientSaveUpdateModal[name] = selectedData.value + "";
    //         // } else if (name === 'Ethnicity') {
    //         // modal[name] = selectedData.display
    //         // PatientSaveUpdateModal[name] = selectedData.value + "";
    //         // } else if (name === 'Race') {
    //         // modal[name] = selectedData.display
    //         // PatientSaveUpdateModal[name] = selectedData.value + "";
    //         // } 
    //         if (name === "LocationID" && !isNull(selectedData)) {
    //             setlocationID(selectedData.value + "")
    //         }
    //         if (name === "ProviderID" && !isNull(selectedData)) {
    //             setProviderID(selectedData.value + "")
    //         }
    //         if (name === "RefProviderID" && !isNull(selectedData)) {
    //             setRefProviderID(selectedData.value + "")
    //         }
    //     } else if (type === 'server' && !isNull(selectedData)) {
    //         // if (name === 'POSCode') {
    //         //     LocationSaveUpdateModal[name] = selectedData.ID
    //         //     setPOS(selectedData.ID)


    //     } else {

    //         modal[name] = ''
    //         PatientSaveUpdateModal[name] = ''
    //     }
    //     setmainPatientModal(modal)
    //     return selectedData
    // }
    //Patient_Adnission_Modal
    const GetPatCounty = (state, city) => {
        let stateData = state ? state : mainPatientModal.State.split('-')[0];
        let cityData = city ? city : mainPatientModal.City;
        // if (isHomeCareCheck === 'true') {
        ServerRequestProtected(API_URL_GENERAL + "/DropDown", 'post', {
            "TableName": enumUtil.enumAPITableName.StateCountyCity,
            "SearchCriteria": {
                "State": stateData,
                "City": cityData
            }
        })
            .then((response) => {
                setCountyList(response)
            })
            .catch((error) => {
                // NotificationHandler(error.message, enumUtil.enumtoaster.error)
                setCountyList([])
                setIsLoading(false)
            })
        // }
    }
    const handleSelectedData = (selectedData, name, type, mode) => {
        setIs(true)
        let modal = { ...mainPatientModal };
        if (type === 'client' && !isNull(selectedData)) {
            if (name === "LocationID") {
                modal[name] = selectedData.display
                PatientSaveUpdateModal[name] = selectedData.value + "";
                setlocationID(selectedData.value + "")

            }
            else if (name === "ShiftID") {
                modal[name] = selectedData.display
                PatientSaveUpdateModal[name] = selectedData.value + "";
                setShiftID(selectedData.value + "")
            }
            else if (name === "ProviderID") {
                if (selectedData?.Active === "false") {

                    setSlectedInActiveData(selectedData)

                    setTimeout(() => {
                        setIsProviderActive(true)
                    }, 100);
                }
                else {
                    modal[name] = selectedData.display
                    PatientSaveUpdateModal[name] = selectedData.value + "";
                    setProviderID(selectedData.value + "")
                }



            } else if (name === "RefProviderID") {
                modal[name] = selectedData.display
                PatientSaveUpdateModal[name] = selectedData.value + "";
                setRefProviderID(selectedData.value + "")
            } else if (name === "State") {
                modal[name] = selectedData.display
                PatientSaveUpdateModal[name] = selectedData.value + "";
                GetPatCounty(selectedData.value)
            } else {
                modal[name] = selectedData.display
                PatientSaveUpdateModal[name] = selectedData.value + "";
            }
        } else if (type === 'server' && !isNull(selectedData)) {
            // if (name === 'POSCode') {
            //     LocationSaveUpdateModal[name] = selectedData.ID
            //     setPOS(selectedData.ID)


        } else {

            modal[name] = ''
            PatientSaveUpdateModal[name] = ''
        }
        setmainPatientModal(modal)
        return selectedData
    }

    console.log('is', is);

    const handleAssignInActiveProvider = () => {
        // skipNextFocus.current = true;
        // console.log();

        // setIs(true)
        setmainPatientModal({ ...mainPatientModal, ProviderID: slectedInActiveData.display })
        setPatientSaveUpdateModal({ ...PatientSaveUpdateModal, ProviderID: slectedInActiveData.value + "" })
        setProviderID(slectedInActiveData.value + "")
        setIsProviderActive(false)
        // setTimeout(() => {
        //     skipNextFocus.current = false;
        // }, 100);
    }

    const handleSelectedAdmissionData = (selectedData, name, type, mode) => {
        let modal = { ...mainPatientAdmissionmodal };
        if (type === 'client' && !isNull(selectedData)) {
            if (name === 'AdmissionStatus') {
                modal[name] = selectedData.display
                PatientAdmissionSaveUpdateModal[name] = selectedData.value + "";
            }
        } else if (type === 'server' && !isNull(selectedData)) {
            // if (name === 'POSCode') {
            //     LocationSaveUpdateModal[name] = selectedData.ID
            //     setPOS(selectedData.ID)


        } else {

            modal[name] = ''
            PatientAdmissionSaveUpdateModal[name] = ''
        }
        setmainPatientAdmissionmodal(modal)
        return selectedData
    }
    const handleMUltiSelectedData = (selectedDataArray, type, name) => {
        let modal = { ...mainPatientModal };
        // console.log("arry", selectedDataArray);
        // console.log("arry type", type);
        if (type === 'server' && selectedDataArray.length > 0) {
            const displayValues = selectedDataArray.map(data => data.display);
            const valueValues = selectedDataArray.map(data => data.value);

            modal[name] = displayValues.join(', ');
            PatientSaveUpdateModal[name] = valueValues.join(', ');
        } else if (type === 'client' && selectedDataArray.length > 0) {
            const displayValues = selectedDataArray.map(data => data.display);
            const valueValues = selectedDataArray.map(data => data.value);
            modal[name] = displayValues.join(', ');
            PatientSaveUpdateModal[name] = valueValues.join(', ');
        }
        else {
            console.log("selectedDataArray");
            modal[name] = '';
            PatientSaveUpdateModal[name] = '';
        }

        setmainPatientModal(modal);
        setPatientSaveUpdateModal(PatientSaveUpdateModal);
        return selectedDataArray;
    }

    const handleGenderCheck = (e) => {
        let value = e.target.value
        ServerRequestProtected(API_URL_Patient + "/CheckGender", 'post', {
            "Value": value,
            "TableName": enumUtil.enumAPITableName.PatientDMGData
        }).then((response) => {
            mainPatientModal.Gender = response.result
            mainPatientModal.MaritalStatus = response.result
            setIsLoading(false)
        }).catch((error) => {
            // NotificationHandler(error.message, enumUtil.enumtoaster.error)
            setIsLoading(false)
        })
    }
    const handleMultipleSelect = (value, type) => {
        let RaceData = [];
        let EthicityData = [];
        if (type === 'Race') {
            value.map((key, index) => {
                RaceData.push(key.value)
            })
            setPatientSaveUpdateModal({
                ...PatientSaveUpdateModal, Race: RaceData.toString()
            })
            setRace(value)
        } else if (type === 'Ethnicity') {
            value.map((key, index) => {
                EthicityData.push(key.value)
            })
            setPatientSaveUpdateModal({
                ...PatientSaveUpdateModal, Ethnicity: EthicityData.toString()
            })
            setEthnicity(value)
        }
    }
    const handleMissingData = (ID) => {
        setIsLoading(true)
        ServerRequestProtected(API_URL + "/PatientReview", 'post', {
            "ID": ID,
            "TableName": enumUtil.enumAPITableName.PATIENTVALIDATION
        }).then((response) => {
            setIsLoading(false)
            setMissingData(true)
            let splitedData = response.split(';')
            setMissingDataInfo(splitedData)
        }).catch((error) => {
            // NotificationHandler(error.message, enumUtil.enumtoaster.error)
            setIsLoading(false)
            setMissingData(false)
        })

    }
    const handleOpenMissingData = () => {
        setIsOpenMissing(true)
    }
    // const handleMultiSelect = (selectedDataArray, name, type, setModal) => {
    //     let modal = { ...setModal() };
    //     let newDataObject = {};

    //     selectedDataArray.forEach(selectedData => {
    //         if (type === 'client' && !isNull(selectedData)) {
    //             console.log("selectedDataArray", selectedDataArray);
    //             modal[name] = selectedData.display;
    //             setPatientSaveUpdateModal(prevModal => ({ ...prevModal, [name]: selectedData.value + "" }));
    //             newDataObject[name] = !isNull(selectedData) ? selectedData.value + "" : '';
    //         }
    //     });
    //     setModal(modal);
    //     setmainPatientModal(modal)
    //     return newDataObject;
    // };
    const handleMultiSelectnew = (data, type) => {
        let selectedData = [];
        console.log(data, 'getdata');
        if (type === 'server') {
            if (data.length === 1) {
                setmainPatientModal({ ...mainPatientModal, Marketer: data.display })
                setPatientSaveUpdateModal({ ...PatientSaveUpdateModal, Marketer: data.value })

                // selectedData=[{...save,Race:data[0]?.display || ''}]
                // setSave(selectedData);
            } else {
                const values = data.map(item => item.display).join(', ');
                // selectedData=[{...save,Race:values}]
                // setSave(selectedData);
            }
        }
        else if (type === 'client') {
            if (data.length === 1) {
                // setSave({...save,Race:data[0]?.value || ''});

            }
            else {
                // const values = data.map(item => item.display).join(', ');
                // setSave({...save,Race:values});
            }
        }
        // console.log(mainPOSModal,'data from supersearch')
    }
    const onCloseDelete = () => {
        // setDel(false);
        setIsOpenDelete(false)
        setIsclose((Math.random()));
    }
    const handleDeleteModal = (ID) => {
        setID(ID)
        setIsOpenDelete(true)
    }
    const DeleteDocument = () => {
        setIsLoading(true)
        ServerRequestProtected(API_URL_GENERAL + "/DeleteSingleRecord", 'post', {
            "ID": itemToDelete.PatientAdmissionStatusID,
            "TableName": enumUtil.enumAPITableName.PatientAdmissionStatus,
        }).then((response) => {
            setIsLoading(false)
            NotificationHandler('Deleted Successfully!', enumUtil.enumtoaster.success);
            setIsclose((Math.random()));
            setshowPopup(false)
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            setshowPopup(false)
        })
    }
    const confirmDelete = (item) => {
        setshowPopup(true)
        setItemToDelete(item);
    };
    const handleEditadmission = (item) => {
        setmainPatientAdmissionmodal({
            ...item,
            PatientAdmissionStatusID: item.PatientAdmissionStatusID + ""
        });
    }
    const getInitials = (firstName, lastName) => {
        const firstInitial = firstName ? firstName[0].toUpperCase() : '';
        const lastInitial = lastName ? lastName[0].toUpperCase() : '';
        return firstInitial + lastInitial;
    };
    const userInitials = getInitials(mainPatientModal.FirstName, mainPatientModal?.LastName);
    let DeleteConfirmation = "";
    if (isOpenDelete) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenDelete} onCloseDelete={onCloseDelete} API_URL={API_URL} TableName={enumUtil.enumAPITableName.Patient} ID={id} onClose={onCloseDelete} />
    }
    const [popup, setPopup] = useState(<></>);
    let LocationPopup = useMemo(() => { return <OpenQuickPopup ID={locationID + ""} name={'Location'} setPopup={setPopup} popupName={'Location'} type={"Label"} /> }, [mainPatientModal])
    let ProviderPopup = useMemo(() => { return <OpenQuickPopup ID={providerID + ""} name={'Provider'} setPopup={setPopup} popupName={'Provider'} type={"Label"} /> }, [mainPatientModal])
    let RefProviderPopup = useMemo(() => { return <OpenQuickPopup ID={RefproviderID + ""} name={'RefProvider'} setPopup={setPopup} popupName={'Ref Provider'} type={"Label"} /> }, [mainPatientModal])

    // useEffect(() => {
    //     GetPatCounty(countyDropdown)

    // }, [countyDropdown])

    const handleClosePopup = () => {
        setshowPopup(false)
    }
    const [isOpenAudit, setisOpenAudit] = useState(false);

    const handleAuditModal = () => {
        setisOpenAudit(true)
    }
    const onCloseAudit = () => {
        setisOpenAudit(false)
    }
    let AuditPopup = "";
    if (isOpenAudit) {
        AuditPopup = <Audit isOpenAudit={isOpenAudit} onCloseAudit={onCloseAudit} ParentID={PatientID + ""} TableName={enumUtil.enumAPITableName.PATIENT} />
    }

    const [editImage, setEditImage] = useState(false)

    const handleImageChange = (e) => {
        const Type = e.target.files[0].type.substring(0, 5);
        if (Type === 'image') {
            let file = e.target.files[0]
            let reader = new FileReader();
            reader.onloadend = () => {
                let value = reader.result.toString();
                setmainPatientModal({ ...mainPatientModal, Picture: value })
                setPatientSaveUpdateModal({ ...PatientSaveUpdateModal, Picture: value })
            }
            reader.readAsDataURL(file);
        }

    }
    const RemovePicture = () => {
        setmainPatientModal({ ...mainPatientModal, ProfilePicture: "" })
        setPatientSaveUpdateModal({ ...PatientSaveUpdateModal, ProfilePicture: "" })
    }
    const AddNotesName = () => {
        return (
            <p className="heading">Add Notes</p>
        )
    }

    const AddIsPorvider = () => {
        return (
            <p className="heading">Assign Inactive Provider?</p>
        )
    }
    const [notesPopup, setNotesPopup] = useState(false)
    const [notesGenderPopup, setGenderotesPopup] = useState(false)



    const handleOpenNotesPopup = () => {

        setNotesPopup(true)
    }
    const handleNotesPopupClose = () => {
        setNotesPopup(false)
    }
    const handleGenderOpenNotesPopup = () => {

        setGenderotesPopup(true)
    }
    const handleGenderNotesPopupClose = () => {
        setGenderotesPopup(false)
    }
    // const [isDiscardChanges, setIsDiscardChanges] = useState(false)
    const [initialState, setInitialState] = useState();
    const NullToEmpty = (data) => {
        let updatedData = data && data.map(item => {
            const updatedItem = { ...item };
            for (const key in updatedItem) {
                if (updatedItem[key] != null) {
                    updatedItem[key] = updatedItem[key] + "";
                } else if (updatedItem[key] === null) {
                    updatedItem[key] = "";
                }
            }
            return updatedItem;
        });
        return updatedData
    }
    useEffect(() => {
        console.log(PateintIDR);

        if (PateintIDR !== -1 || PateintIDR !== '-1') {
            let main = NullToEmpty([mainPatientModal])[0]
            let copy = NullToEmpty([initialState])[0]
            main.ProfilePicture = ""
            copy.ProfilePicture = ""
            if (!isNull(initialState)) {
                if (DropDowns.DiscardIndicator) {
                    const hasChanged = !_.isEqual(main, copy);
                    if (hasChanged) {
                        let DD = DropDowns
                        DD?.DisCardActiveIds.Patient.map((item) => {
                            if (item.PatientID + "" === PatientID + "") {
                                item.isDemographicsUpdated = true
                            }
                        })
                        dispatch(GeneralDropDowns({ ...DD, DiscardIndicator: false }))
                    } else {
                        let DD = DropDowns
                        DD?.DisCardActiveIds.Patient.map((item) => {
                            if (item.PatientID + "" === PatientID + "") {
                                item.isDemographicsUpdated = false
                            }
                        })
                        dispatch(GeneralDropDowns({ ...DD, DiscardIndicator: false }))
                    }
                }
            } else {
                dispatch(GeneralDropDowns({ ...DropDowns, DiscardIndicator: null }))
            }
        } else {
            dispatch(GeneralDropDowns({ ...DropDowns, DiscardIndicator: null }))
        }
    }, [DropDowns.DiscardIndicator])
    // const onProceedWithDiscardChanges = () => {
    //     dispatch(GeneralDropDowns({ ...DropDowns, DiscardIndicator: false }))
    //     setIsDiscardChanges(false)
    // }
    // const handleCancelDiscard = () => {
    //     setIsDiscardChanges(false)
    //     dispatch(GeneralDropDowns({ ...DropDowns, DiscardIndicator: null }))
    // }
    // const nPopup = ''
    // if (notesPopup) {
    //     nPopup
    // }

    // let DiscardPopup
    // if (isDiscardChanges) {
    //     DiscardPopup = <DiscardChangesPopup isDiscardChanges={isDiscardChanges} handleCancelDiscard={handleCancelDiscard} onProceedWithDiscardChanges={onProceedWithDiscardChanges} />
    // }
    const sendInvitationTpPatient = () => {
        if (isNull(mainPatientModal.Email)) {
            NotificationHandler('Email is required to send invitation', enumUtil.enumtoaster.error);
            return;
        }
        if (mainPatientModal.Status === 'InActive' || isNull(mainPatientModal.Status)) {
            setIsLoading(true)
            ServerRequestProtected(enumUtil.controller.PatientPortalLogin + "/RegisterPatientUser", 'post', {
                "Data": {
                    "PatientID": PateintIDR + "",
                    "Email": mainPatientModal.Email
                },
                'ID': '0',
                "TableName": enumUtil.enumAPITableName.PatientPortal,
            }).then((response) => {
                LoadDemographics()
                setIsLoading(false)
                NotificationHandler('Invitation email sent successfully', enumUtil.enumtoaster.success);
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            })
        }
    }
    const sendReinviteToPatient = () => {
        setIsLoading(true)
        ServerRequestProtected(enumUtil.controller.PatientPortalLogin + "/RegisterPatientUser", 'post',
            {
                "Data": {
                    "PatientID": PateintIDR + "",
                    "Email": mainPatientModal.Email,
                    "ReInvite": "true"
                },
                'ID': '0',
                "TableName": enumUtil.enumAPITableName.PatientPortal,
            }).then((response) => {
                LoadDemographics()
                setIsLoading(false)
                NotificationHandler('Re-invitation email sent successfully', enumUtil.enumtoaster.success);
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            })
    }
    const revokePatientAccess = () => {
        setIsLoading(true)
        ServerRequestProtected(enumUtil.controller.PatientPortalLogin + "/RevokePatientAccess", 'post', {
            "Data": {
                "PatientID": PateintIDR + ""
            },
            'ID': '0',
            "TableName": enumUtil.enumAPITableName.PatientPortal,
        }).then((response) => {
            LoadDemographics()
            setIsLoading(false)
            NotificationHandler('Patient access revoked successfully', enumUtil.enumtoaster.success);
        }
        ).catch((error) => {
            setIsLoading(false)
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
        })
    }
    let SidebarActive = useSelector(state => state.SidebarActiveTab);
    const isOnPatientSubTab212 = DropDowns?.PatientSubActiveTab === 212 && SidebarActive === 2;
    const enabled =
        isOnPatientSubTab212 &&
        props.ActivePatientID === PatientID;
    useKeyboardShortcut("s+c", handleSavePatient, 300, enabled);
    const GetCountyOnBlur = () => {
        GetPatCounty()
    }


    // intake template forms
    const [isOpenDemoForm, setisOpenDemoForm] = useState(false)
    const handleOpenIntakeForm = () => {
        setisOpenDemoForm(true)
    }
    const handleCloseForm = () => {
        setisOpenDemoForm(false)
    }
    let DemographicFormPopup

    if (isOpenDemoForm) {
        DemographicFormPopup = <MergeDemographicsForm mergeInfoForm={isOpenDemoForm} onClose={handleCloseForm} ID={mainPatientModal.PatientIntakeTemplateDataID + ""} />
    }
    const handleCancelProvider = () => {
        setIsProviderActive(false)
        setmainPatientModal({ ...mainPatientModal, ProviderID: "" })
        setPatientSaveUpdateModal({ ...PatientSaveUpdateModal, ProviderID: "" })
    }

    const getLevelOfCareDisplay = (framework, value) => {
        if (!value) return '-';

        if (framework === 'ASAM') {
            const option = ASAMLevelOfCareDropdown.find(item => item.value === value);
            return option ? option.display : value;
        } else if (framework === 'LOCUS') {
            const option = LOCUSLevelOfCareDropdown.find(item => item.value === value);
            return option ? option.display : value;
        }
        return value;
    };

    const PateintName = [mainPatientModal.FirstName, mainPatientModal.LastName].filter(Boolean).join(' ');

    const getSaveData = async (_, filename, base64, options = {}) => {
        console.log("get Save Data Sign ,", filename, base64, options);
        let newData = {
            "SignatureFileName": filename,
            "SignaturePath": base64,
            "IsDefaultSignature": (options.isDefaultSignature || false).toString()
        };
        setmainPatientModal(prev => ({ ...prev, ...newData }));
        setPatientSaveUpdateModal(prev => ({ ...prev, ...newData }));
    };


    const [modalImg, setModalImg] = useState(null)
    const handleOpenImg = (type) => {
        // console.log("isSignUploadedhandleOpenImg", isSignUploaded)
        let isSignUploaded = mainPatientModal?.SignatureFileName?.includes('uploaded-signature');
        if (!isSignUploaded) return;

        if (type === 'unsaved') {
            setModalImg(`data:image/png;base64,${PatientSaveUpdateModal.SignaturePath}`);
        } else {
            setModalImg(imgFile)
        }

        setPrintOutModal(true)
    }

    const handleRemoveFile = () => {
        let newData = {
            "SignatureFileName": '',
            "SignaturePath": '',
            "IsDefaultSignature": 'false',
        }
        setmainPatientModal(prev => ({ ...prev, ...newData }))
        setPatientSaveUpdateModal(prev => ({ ...prev, ...newData }))
        setImgFile(null);
        setModalImg(null);
    }


    const ViewFile = (SignaturePath) => {
        if (!isNull(SignaturePath)) {
            // setPdfFile(null);
            // setTxtFile(null);
            setImgFile(null);
            setModalImg(null);
            setIsLoading(true);
            ServerRequestPublic(
                API_URL_Wasabi + "/DownloadFile",
                "post",
                {
                    BucketPath: SignaturePath,
                },
                "Download"
            )
                .then((response) => {
                    setIsLoading(false);

                    if (response.type === "application/txt") {
                        // const blob = response;
                        // const reader = new FileReader();
                        // reader.onload = () => {
                        //     const content = reader.result;
                        //     setTxtFile(content);
                        // };

                        // reader.readAsText(blob, "utf-8");
                    } else if (["application/png", "application/jpg", "application/jpeg", "application/tiff"].includes(response.type)) {
                        const blob = response;
                        const objectURL = URL.createObjectURL(blob);
                        setImgFile(objectURL);
                    } else if (response.type === "application/pdf") {
                        // const blob = response;
                        // const objectURL = URL.createObjectURL(blob);
                        // setPdfFile(objectURL);
                    } else {
                        // let file = new Blob([response]);
                        // const fileUrl = URL.createObjectURL(file);
                        // setPdfFile(fileUrl);
                    }
                    // setModalActive(true);
                })
                .catch((error) => {
                    setIsLoading(false);
                    NotificationHandler("File Not Found", enumUtil.enumtoaster.error);
                });
        }
    };

    const [SignatureLink, setSignatureLink] = useState('')

    const handleShareSignature = () => {
        if (!PatientID || PatientID === '-1') {
            NotificationHandler('Please save the patient record before sharing the email with the patient.', enumUtil.enumtoaster.error);
            return;
        }
        if (!mainPatientModal.Email) {
            NotificationHandler('Please add the patient email before sharing the signature.', enumUtil.enumtoaster.error);
            return;
        }

        const emailError = FormValidator(mainPatientModal.Email, enumUtil.enumValidationType.Email, 'Email');
        if (emailError) {
            NotificationHandler('Please enter a valid email address.', enumUtil.enumtoaster.error);
            return;
        }
        setIsSharing(true);
        setIsLoading(true)
        ServerRequestProtected(API_URL + "/PatientSignature", 'post', {
            TableName: enumUtil.enumAPITableName.Patient,
            "Data": {
                PatientID: PatientID,
            }
        })
            .then((response) => {
                setIsLoading(false)
                setIsSharing(false);
                NotificationHandler('Shared successfully!', enumUtil.enumtoaster.success);
                // If backend returns a link/GUID, you can handle it here
                setSignatureLink(response?.link)
                console.log("Full response:", response?.data);
            })
            .catch((error) => {
                setIsSharing(false);
                setIsLoading(false)
                NotificationHandler(error.response?.data || 'Failed to share', enumUtil.enumtoaster.error);
            });
    };
    return (
        <>
            {/* {DiscardPopup} */}
            {DeleteConfirmation}
            {AuditPopup}
            {DemographicFormPopup}
            {isLoading ? <Loader /> : null}
            <Modal show={showPopup} onHide={showPopup} backdrop="static" keyboard={false} centered dialogClassName="delete-modal hk-modal-v1 za-exit-group za-update-subscriber-id za-update-authoriaztion">
                <Modal.Body>
                    {isLoading ? <Loader /> : null}
                    <div className='d-flex align-items-center justify-content-between mb-12'>
                        <p className="heading fs-14 dark-clr">Delete Action?</p>
                        <i className="icon-x-cros fs-20" onClick={handleClosePopup}></i>
                    </div>
                    <div className='paragraph d-flex gap-1 m-0 align-items-center py-1'>
                        <i className='icon-Vector13 fs-14'></i>
                        <p className=' text'>Are you sure you want to delete?</p>
                    </div>
                </Modal.Body>
                <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                    <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={handleClosePopup}> No</button>
                    <button className="btn btn-danger px-10 h-100" onClick={DeleteDocument}> Yes</button>
                </div>
            </Modal>
            <div className="tabs-container screen-size">
                <div className="min-h-inherit">
                    <div className="row g-0 demograpics_screen_size">
                        <div className="col-md-4 br-clr br-right-1 position-relative">
                            <div className="p-3">
                                <div className='row justify-content-between'>
                                    <div className="col-md-6">
                                        <div className="patient-profile-img h-auto w-max-content">
                                            <div className=" position-relative">
                                                <div class="">
                                                    {mainPatientModal.ProfilePicture ? (
                                                        <div className="img-container s-100 circle m-auto">
                                                            <img src={mainPatientModal.ProfilePicture}
                                                                draggable="false"
                                                                onContextMenu={e => e.preventDefault()}
                                                                style={{
                                                                    pointerEvents: 'none',
                                                                    userSelect: 'none'
                                                                }}
                                                            />
                                                        </div>
                                                    ) :
                                                        <div class="img-container circle s-100">
                                                            <p className={`align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white ${genderClass}`}>
                                                                <h1 className="justify-content-center">{userInitials}</h1>
                                                            </p>
                                                        </div>
                                                    }
                                                </div>

                                                {mainPatientModal?.ProfilePicture ? (
                                                    <div className="ar-edit demograpics">
                                                        <i className="icon-edit-pencil fs-11" onClick={() => setEditImage(true)}></i>
                                                    </div>
                                                ) : <></>}

                                                {editImage &&
                                                    <div className="pic_edit start-100">
                                                        <div className="d-flex flex-column row-gap-15">
                                                            <div className="d-flex justify-content-between cursor-pointer">
                                                                <p className="heading dark-clr">Edit Profile Picture</p>
                                                                <i className="icon-x-cros dark-clr fw-600" onClick={() => setEditImage(false)}></i>
                                                            </div>
                                                            <div class="hk-imgHandler">
                                                                <div className="d-flex hk-imgHandler img-container justify-content-center mx-auto s-85">
                                                                    {mainPatientModal?.ProfilePicture ? <img src={mainPatientModal?.ProfilePicture} /> :

                                                                        mainPatientModal?.Gender === 'Male' ? <p class="align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white za-male rounded-1 fs-30">{userInitials}</p> : mainPatientModal?.Gender === 'Female' ? <p class="align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white za-female rounded-1 fs-30">{userInitials}</p> : <p class="align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white za-others rounded-1 fs-30">{userInitials}</p>


                                                                    }
                                                                    <input type="file"
                                                                        id="ProfilePicture"
                                                                        name="ProfilePicture"
                                                                        accept=".jpg, .jpeg, .png, "
                                                                        onChange={handlePatientProfileChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <div className="text-center mb-1">
                                                                    <button className="btn rounded px-2 btn-validate hk-imgHandler mx-auto"><i className="icon-upload me-1 fs-11"></i>
                                                                        <input type="file"
                                                                            className=''
                                                                            id="ProfilePicture"
                                                                            name="ProfilePicture"
                                                                            onChange={handlePatientProfileChange}
                                                                        />
                                                                        Upload Image</button>
                                                                </div>
                                                                <div className="d-flex align-items-center gap-6">
                                                                    <div className="br-bottom-1 br-clr-light w-100"></div>
                                                                    <p className="heading light-clrs fs-11">or</p>
                                                                    <div className="br-bottom-1 br-clr-light w-100"></div>
                                                                </div>
                                                                {/* onClick={RemovePicture} */}
                                                                <p className="heading mt-1 del_item text-center cursor-pointer" onClick={RemovePicture}>Delete Exisiting</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }

                                            </div>
                                            {mainPatientModal?.ProfilePicture ? <></> :
                                                <div class="upload-patient-img  ">
                                                    <label class="d-flex align-items-center  gap-10">
                                                        <input type="file"
                                                            id="ProfilePicture"
                                                            name="ProfilePicture"
                                                            accept=".jpg, .jpeg, .png, "
                                                            onChange={handlePatientProfileChange} />
                                                        <i class="bi bi-camera-fill  lh-1" />
                                                    </label>
                                                </div>
                                            }
                                            {/* <div class="upload-patient-img  ">
                                        <input type="file" id="upload-patient-img"/>
                                        <label for="upload-patient-img" class="d-flex align-items-center  gap-10">
                                            <i class="bi bi-camera-fill  lh-1"></i>
                                        </label>
                                    </div> */}
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <div class="form-check form-switch radio_button hk-active__btn mb-0">
                                                <label class="form-check-label" for="mySwitch">Active</label>
                                                <input
                                                    class="form-check-input"
                                                    type="checkbox"
                                                    id="mySwitch"
                                                    name="Statuss"
                                                    autoComplete="off"
                                                    checked={mainPatientModal.Statuss}
                                                    onChange={handlePatientChange}
                                                />
                                            </div>
                                            <div className="app_tooltip left">
                                                <span className="icon-menu-1" onClick={handleAuditModal}><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span><span className="path8"></span><span className="path9"></span><span className="path10"></span></span>
                                                <p class="tool_tip xsm_text text-light">Audit</p>
                                            </div>
                                        </div>
                                        <div className='form-group input flex-grow-1 mt-3'>
                                            <label >Account Number</label>
                                            <input
                                                type="text"
                                                className='form-control'
                                                name="AccountNumber"
                                                id="AccountNumber"
                                                autoComplete="off"
                                                value={mainPatientModal.AccountNumber}
                                                onChange={handlePatientChange}
                                                onKeyPress={(event) => handleNumericCheck(event)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-6">
                                        <div className="input">
                                            <label >Last Name <span className='req'>*</span></label>
                                            <div className={PatientValidationModal.LastNameVal ? 'form-group input error mb-3' : 'form-group input'}>

                                                <input type="text"
                                                    className='form-control'
                                                    name="LastName"
                                                    id="LastName"
                                                    autoComplete="off"
                                                    maxLength={35}
                                                    onKeyPress={handleAlphabeticCheck}
                                                    value={mainPatientModal.LastName}
                                                    onChange={handlePatientChange}
                                                />
                                                {PatientValidationModal.LastNameVal}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className='input'>
                                            <label >First Name <span className='req'>*</span></label>
                                            <div className={PatientValidationModal.FirstNameVal ? 'form-group input error mb-3' : 'form-group input'}>
                                                <input type="text"
                                                    className='form-control'
                                                    name="FirstName"
                                                    id="FirstName"
                                                    maxLength={35}
                                                    autoComplete="off"
                                                    // onKeyPress={handleAlphabeticCheck}
                                                    value={mainPatientModal.FirstName}
                                                    onChange={handlePatientChange}
                                                    onBlur={handleGenderCheck}
                                                />
                                                {PatientValidationModal.FirstNameVal}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="row">
                            <div className="col-md-6">
                                <div className="input">
                                    <label >Medicaid # </label>
                                    <div className= 'form-group input'>

                                        <input type="text"
                                            className='form-control'
                                            name="MedicaidNo"
                                            id="MedicaidNo"
                                            maxLength={35}
                                            onKeyPress={handleAlphabeticCheck}
                                            value={mainPatientModal.MedicaidNo}
                                            onChange={handlePatientChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className='input'>
                                    <label >Medicare # </label>
                                    <div className= 'form-group input'>
                                        <input type="text"
                                            className='form-control'
                                            name="MedicareNo"
                                            id="MedicareNo"
                                            maxLength={35}
                                            value={mainPatientModal.MedicareNo}
                                            onChange={handlePatientChange}
                                            onBlur={handleGenderCheck}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div> */}
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className='form-group input'>
                                            <label >Middle Initial</label>
                                            {/* <div className={PatientValidationModal.MIval ? 'form-group input error' : 'input'}> */}
                                            <div className='input'>
                                                <input type="text"
                                                    className='form-control'
                                                    name="MI"
                                                    id="MI"
                                                    // maxLength={3}
                                                    autoComplete="off"
                                                    onKeyPress={handleAlphabeticCheck}
                                                    value={mainPatientModal.MI}
                                                    onChange={handlePatientChange}
                                                />
                                                {/* {PatientValidationModal.MIval} */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className={PatientValidationModal.SSNLengthVal || PatientValidationModal.SSNval ? 'form-group input error' : 'form-group input'}>
                                            <label >SSN</label>
                                            <input type="text"
                                                className='form-control'
                                                name="SSN"
                                                id="SSN"
                                                autoComplete="off"
                                                maxLength={9}
                                                value={mainPatientModal.SSN}
                                                onKeyPress={(event) => handleNumericCheck(event)}
                                                onChange={handlePatientChange}
                                            />
                                            {PatientValidationModal.SSNLengthVal || PatientValidationModal.SSNval}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 demograohics-input">

                                        <div className={PatientValidationModal.DOBVal ? 'form-group input error' : 'form-group input'}>
                                            <label htmlFor="dobInput">DOB <span className='req'>*</span></label>
                                            <DatePicker
                                                id="dobInput"
                                                showLabel={false}
                                                value={mainPatientModal.DOB}
                                                handleCalendarChangefunc={date => handleCalendarChange(date, 'DOB')}
                                            />
                                            {PatientValidationModal.DOBVal}

                                        </div>


                                    </div>
                                    <div className="col-md-6 demograohics-input">
                                        <div className='form-group input'>
                                            <label >Age</label>
                                            <input type="text"
                                                className='form-control'
                                                name="Age"
                                                id="Age"
                                                readOnly
                                                value={mainPatientModal.Age}
                                            />
                                        </div>
                                        {/* <div className='input'>
                                        <label >Marital Status</label>
                                        <SuperSearchList
                                            type="client"
                                            id='MaritalStatus'
                                            name='MaritalStatus'
                                            searchValue={mainPatientModal.MaritalStatus}
                                            data={MaritalStatus}
                                            onChange={handleChangeDD}
                                            getSelectedData={handleSelectedData}
                                            is={is}
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                        />
                                    </div> */}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className={PatientValidationModal.GenderVal ? 'form-group input error mb-3' : 'form-group input'}>
                                            <label >Sex<span className='req'>*</span></label>
                                            <SuperSearchList
                                                type="client"
                                                id='Gender'
                                                name='Gender'
                                                searchValue={mainPatientModal.Gender}
                                                data={GenderDemographic}
                                                onChange={handleChangeDD}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                icon={'Simple'}
                                                sup_btn='sup_btn'
                                                sup_inp='superSearchVisitInp'
                                                inputError={PatientValidationModal.GenderVal}
                                            />
                                            {PatientValidationModal.GenderVal}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className='input'>
                                            <div className={`d-flex align-items-center justify-content-between ${PatientValidationModal.GenderIdentityNotesVal ? 'red-note-icon' : ''}`} >
                                                <label >Gender Identity</label>
                                                {/* <NoteIcon onClick ={handleOpenNotesPopup} /> */}
                                                <span className={` icon-note-icon fs-14`} onClick={handleGenderOpenNotesPopup}><span class="path1"></span><span class="path2"></span></span>
                                            </div>

                                            <SuperSearchList
                                                type="client"
                                                id='GenderIdentity'
                                                name='GenderIdentity'
                                                searchValue={mainPatientModal.GenderIdentity}
                                                data={GenderIdentity}
                                                onChange={handleChangeDD}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                icon={'Simple'}
                                                sup_btn='sup_btn'
                                                sup_inp='superSearchVisitInp'
                                            />
                                        </div>
                                    </div>


                                    <div className="col-md-6">
                                        <div className='input'>
                                            <label >Marital Status</label>
                                            <SuperSearchList
                                                type="client"
                                                id='MaritalStatus'
                                                name='MaritalStatus'
                                                searchValue={mainPatientModal.MaritalStatus}
                                                data={MaritalStatus}
                                                onChange={handleChangeDD}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                icon={'Simple'}
                                                sup_btn='sup_btn'
                                                sup_inp='superSearchVisitInp'
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className='form-group input'>
                                            <label >Maiden Last Name</label>
                                            <input type="text"
                                                className='form-control'
                                                name="MaidenLastName"
                                                id="MaidenLastName"
                                                autoComplete="off"
                                                maxLength={35}
                                                onKeyPress={handleAlphabeticCheck}
                                                value={mainPatientModal.MaidenLastName}
                                                onChange={handlePatientChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <div className='input'>
                                            <label >Prefix</label>
                                            <SuperSearchList
                                                type="client"
                                                id='Prefix'
                                                name='Prefix'
                                                searchValue={mainPatientModal.Prefix}
                                                data={PrefixDropDown}
                                                onChange={handleChangeDD}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                icon={'Simple'}
                                                sup_btn='sup_btn'
                                                sup_inp='superSearchVisitInp'
                                            />
                                        </div>
                                        {/* <div className='form-group input'>
                                        <label >Prefix</label>
                                        <input
                                            type="text"
                                            className='form-control'
                                            name="Prefix"
                                            id="Prefix"
                                            maxLength={35}
                                            autoComplete="off"
                                        
                                        value={mainPatientModal.Prefix}
                                        onChange={handlePatientChange}
                                        />
                                    </div> */}
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <div className='input'>
                                            <label >Suffix</label>
                                            <SuperSearchList
                                                type="client"
                                                id='Suffix'
                                                name='Suffix'
                                                searchValue={mainPatientModal.Suffix}
                                                data={SuffixDropDown}
                                                onChange={handleChangeDD}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                icon={'Simple'}
                                                sup_btn='sup_btn'
                                                sup_inp='superSearchVisitInp'
                                            />
                                        </div>
                                        {/* <div className='form-group input'>
                                        <label >Suffix</label>
                                        <input
                                            type="text"
                                            className='form-control'
                                            name="Suffix"
                                            id="Suffix"
                                            maxLength={35}
                                            autoComplete="off"
                                            // onKeyPress={handleAlphabeticCheck}
                                            value={mainPatientModal.Suffix}
                                            onChange={handlePatientChange}
                                        />
                                    </div> */}
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <div className='form-group input mb-0'>
                                            <label >Previous Name</label>
                                            <input
                                                type="text"
                                                className='form-control'
                                                name="PreviousName"
                                                id="PreviousName"
                                                maxLength={35}
                                                autoComplete="off"
                                                onKeyPress={handleAlphabeticCheck}
                                                value={mainPatientModal.PreviousName}
                                                onChange={handlePatientChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <div className='form-group input mb-0'>
                                            <label >Preferred Name</label>
                                            <input
                                                type="text"
                                                className='form-control'
                                                name="PreferredName"
                                                id="PreferredName"
                                                maxLength={35}
                                                autoComplete="off"
                                                onKeyPress={handleAlphabeticCheck}
                                                value={mainPatientModal.PreferredName}
                                                onChange={handlePatientChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-12 mb-3">
                                        <div className="position-relative sign-here-box provider-sign-box cursor-pointer d-flex align-items-center justify-content-center h-100 py-3">
                                            {!isNull(imgFile) ?
                                                <>
                                                    <div onClick={() => handleOpenImg()}>
                                                        <img
                                                            src={imgFile}
                                                            style={{ maxHeight: '81px' }}
                                                            className="mw-100 px-2"
                                                            alt="Uploaded preview" />
                                                    </div>
                                                    <span className="cross-icon d-flex" onClick={handleRemoveFile}>
                                                        <i className="icon-x-cros fs-14 dark-clr fw-900"></i>
                                                    </span>
                                                </>
                                                :
                                                (PatientSaveUpdateModal.SignaturePath ?
                                                    <div onClick={() => handleOpenImg("unsaved")}>
                                                        <img
                                                            src={`data:image/png;base64,${PatientSaveUpdateModal.SignaturePath}`}
                                                            style={{ maxHeight: '81px' }}
                                                            className="mw-100 px-2"
                                                            alt="Uploaded preview" />
                                                        <span className="cross-icon d-flex" onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleRemoveFile();
                                                        }}>
                                                            <i className="icon-x-cros fs-14 dark-clr fw-900"></i>
                                                        </span>
                                                    </div> :
                                                    (mainPatientModal.SignaturePath && !imgFile && !isLoading) ?
                                                        <>
                                                            <div className='fs-13 ar-light-color text h-100 w-100 d-flex justify-content-center align-items-center' onClick={() => ViewFile(mainPatientModal.SignaturePath)}>Signature failed to load. Click to reload.</div>
                                                            <span className="cross-icon d-flex" onClick={handleRemoveFile}>
                                                                <i className="icon-x-cros fs-14 dark-clr fw-900"></i>
                                                            </span>
                                                        </> :
                                                        <div className='fs-13 ar-light-color text h-100 w-100 d-flex justify-content-center align-items-center' onClick={() => setIsSign(true)}>
                                                            Click to add signature...</div>)}
                                        </div>
                                    </div>
                                    {mainPatientModal.SignaturePath ? null :
                                        <div className="col-md-12">
                                            <div className="share-pateint-signature">
                                                <div className="d-flex align-items-center gap-6 mb-2px">
                                                    <i className='icon-Share fs-12'></i>
                                                    <p className='text font-m'>Share with patient </p>
                                                </div>
                                                <p className="text fs-11">A secure link to allow the patient to add their signature remotely.</p>

                                                <div className="mt-10 d-flex align-items-center gap-2">
                                                    <div className="link-view ps-2 w-100 min-w-0 d-flex align-items-center user-select-none">
                                                        <p className='text text-nowrap validation_message'>{SignatureLink}</p>
                                                    </div>
                                                    <div className="d-flex align-items-center gap-6">
                                                        {/* <div className="ar-btn copy-btn px-2 flex-center">
                                                            <IconCopy />
                                                        </div> */}
                                                        <div className="ar-btn px-2 flex-center" onClick={handleShareSignature}>
                                                            <i className='icon-Send fs-11'></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <SignEncounter
                                        isSign={isSign}
                                        setIsSign={setIsSign}
                                        providerName={PateintName}
                                        setSearchParam={() => { }}
                                        getSaveData={getSaveData}
                                        isOpenedFrom={'PatientDefaultSignature'}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-8">
                            {PateintIDR === -1 || !PatientPortalAccessRedux ? null :
                                <div className="star-healthcare-portal ps-2 py-2px d-flex align-items-center justify-content-between me-4 pe-2px">
                                    <p className="heading">STARCARE Portal</p>
                                    {isNull(mainPatientModal.Status) ?
                                        <p className="text font-m text-decoration-underline validate-color cursor-pointer user-select-none py-2px" onClick={() => sendInvitationTpPatient()}>Click to invite patient</p>
                                        :
                                        <div className='d-flex align-items-center gap-2'>
                                            <p className="heading">Status: <span className={`fst-italic ${mainPatientModal.Status === 'Active' ? 'Paid-clr' : 'Denied-clr'} `}>{mainPatientModal.Status}</span></p>
                                            <p className='text fs-14 font-m light-clrs'>|</p>
                                            <p className="heading">By, Date: <span className='text'>{mainPatientModal.UserCreatedBy + ' ' + mainPatientModal.UserCreatedDate} </span></p>
                                            <p className='text fs-14 font-m light-clrs'>|</p>
                                            <p className="text font-m text-decoration-underline validate-color cursor-pointer user-select-none py-2px"
                                                onClick={() => {
                                                    if (mainPatientModal.Status === 'Active') {
                                                        revokePatientAccess();
                                                    } else if (mainPatientModal.Status === 'InActive') {
                                                        sendReinviteToPatient();
                                                    }
                                                }}
                                            >
                                                {mainPatientModal.Status === 'Active' ? 'Click to revoke access' : mainPatientModal.Status === 'InActive' ? 'Click to reinvite' : ''}
                                            </p>
                                        </div>
                                    }
                                </div>
                            }
                            {mainPatientModal.IsFormSubmitted === 'true' && PatientPortalAccessRedux ?
                                <div className='ar-alert d-flex align-items-center gap-1 m-0 mb-2px w-100'>
                                    <i className='icon-alert'></i>
                                    <p className='text'>Patient submitted <span className='heading'>Patient Demographics Form</span> that may update information displayed on this page. <span className="validate-color cursor-pointer" onClick={handleOpenIntakeForm}>Click to review and mark it as processed.</span></p>
                                </div>
                                : null}


                            <div className="app-accordian pb-5">
                                <Accordion expanded={expanded === 'Pateint1-content'} onChange={handleChangeAccodian('Pateint1-content')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="Pateint1-content"
                                        id="address-header"
                                    >
                                        <p className="heading">Address Information</p>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div className='row row-gap-15 row-half'>
                                            <div className="col-md-6">
                                                <div className='input'>
                                                    <label>Address Line 1</label>
                                                    <input type="text" className='form-control'
                                                        name="AddressLine1"
                                                        id="AddressLine1"
                                                        autoComplete="off"
                                                        value={mainPatientModal.AddressLine1}
                                                        onChange={handlePatientChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className='input'>
                                                    <label >Address Line 2</label>
                                                    <input type="text" className='form-control'
                                                        name="AddressLine2"
                                                        id="AddressLine2"
                                                        autoComplete="off"
                                                        value={mainPatientModal.AddressLine2}
                                                        onChange={handlePatientChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className='row row-half mt-3'>
                                                    <div className="col-md-3">
                                                        <div className='input'>
                                                            <label >City</label>
                                                            <input type="text" className='form-control'
                                                                name="City"
                                                                id="City"
                                                                autoComplete="off"
                                                                maxLength={30}
                                                                value={mainPatientModal.City}
                                                                onChange={handlePatientChange}
                                                                onBlur={GetCountyOnBlur}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className='input'>
                                                            <label >State</label>
                                                            <SuperSearchList
                                                                type="client"
                                                                id='State'
                                                                name='State'
                                                                searchValue={mainPatientModal.State}
                                                                data={States}
                                                                onChange={handleChangeDD}
                                                                getSelectedData={handleSelectedData}
                                                                is={is}
                                                                sup_btn='sup_btn-Inp'
                                                                sup_inp='superSearchVisitInp'
                                                            // filterWith="startsWith"
                                                            // tableHeight="200px"
                                                            // tableWidth="100%"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className='form-group input'>
                                                            <label >Zip Code</label>
                                                            <div className={PatientValidationModal.ZipCodeVal || PatientValidationModal.ZipCodeLengthVal ? 'input error' : 'input'}>
                                                                <input type="text" className='form-control'
                                                                    name="ZipCode"
                                                                    id="ZipCode"
                                                                    autoComplete="off"
                                                                    maxLength={9}
                                                                    value={mainPatientModal.ZipCode}
                                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                                    onChange={handlePatientChange}
                                                                />
                                                                {PatientValidationModal.ZipCodeVal || PatientValidationModal.ZipCodeLengthVal}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className='input'>
                                                            <label >Neighborhood</label>
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                name="Neighborhood"
                                                                id="Neighborhood"
                                                                autoComplete="off"
                                                                value={mainPatientModal.Neighborhood}
                                                                onChange={handlePatientChange}
                                                            />
                                                            {/* <SuperSearchList
                                                            type="client"
                                                            id='Neighborhood'
                                                            name='Neighborhood'
                                                            searchValue={mainPatientModal.Neighborhood}
                                                            data={DropDowns.Location}
                                                            onChange={handleChangeDD}
                                                            getSelectedData={handleSelectedData}
                                                            is={is}
                                                            sup_btn='sup_btn-Inp'
                                                            sup_inp='superSearchVisitInp'
                                                        /> */}
                                                        </div>
                                                    </div>
                                                    {/* {isHomeCareCheck === 'true' ? */}
                                                    <div className="col-md-3">
                                                        <div className='input'>
                                                            <label >County</label>
                                                            <SuperSearchList
                                                                type="client"
                                                                id='County'
                                                                name='County'
                                                                searchValue={mainPatientModal.County}
                                                                data={CountyList}
                                                                onChange={handleChangeDD}
                                                                getSelectedData={handleSelectedData}
                                                                is={is}
                                                                sup_btn='sup_btn-Inp'
                                                                sup_inp='superSearchVisitInp'
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* : null} */}
                                                    <div className="col-md-3">
                                                        <div className='form-group input'>
                                                            <label >Cell Phone</label>
                                                            <div className={PatientValidationModal.MobileNumberlen ? 'input error' : 'input'}>
                                                                <input
                                                                    type="text"
                                                                    className='form-control'
                                                                    name="MobileNumber"
                                                                    id="MobileNumber"
                                                                    placeholder="(555) 555-5555"
                                                                    autoComplete="off"
                                                                    value={mainPatientModal.MobileNumber}
                                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                                    onChange={handlePatientChange}
                                                                />
                                                                {PatientValidationModal.MobileNumberlen}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className='form-group input'>
                                                            <label >Home Phone </label>
                                                            <div className={PatientValidationModal.HomePhoneNumberlen ? 'input error' : 'input'}>
                                                                <input
                                                                    type="text"
                                                                    className='form-control'
                                                                    name="HomePhoneNumber"
                                                                    id="HomePhoneNumber"
                                                                    placeholder="555-555-5555"
                                                                    autoComplete="off"
                                                                    value={mainPatientModal.HomePhoneNumber}
                                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                                    onChange={handlePatientChange}
                                                                />
                                                                {PatientValidationModal.HomePhoneNumberlen}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-3" >
                                                        <div className='form-group input'>
                                                            <label >Work Phone</label>
                                                            <div className={PatientValidationModal.WorkNumberlen ? 'input error' : 'input'}>
                                                                <input
                                                                    type="text"
                                                                    className='form-control'
                                                                    name="WorkNumber"
                                                                    id="WorkNumber"
                                                                    placeholder="(555) 555-5555"
                                                                    autoComplete="off"
                                                                    value={mainPatientModal.WorkNumber}
                                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                                    onChange={handlePatientChange}
                                                                />
                                                                {PatientValidationModal.WorkNumberlen}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className='form-group input'>
                                                            <label >Work Phone Extension</label>
                                                            <div className={PatientValidationModal.WorkPhoneExtentionlen ? 'input error' : 'input'}>
                                                                <input
                                                                    type="text"
                                                                    className='form-control'
                                                                    name="WorkPhoneExtention"
                                                                    id="WorkPhoneExtention"
                                                                    autoComplete="off"
                                                                    maxLength={4}
                                                                    value={mainPatientModal.WorkPhoneExtention}
                                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                                    onChange={handlePatientChange}
                                                                />
                                                                {PatientValidationModal.WorkPhoneExtentionlen}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className='form-group input mb-0'>
                                                            <label >Other Phone </label>
                                                            <div className={PatientValidationModal.OtherPhoneNumberlen ? 'input error' : 'input'}>
                                                                <input
                                                                    type="text"
                                                                    className='form-control'
                                                                    name="OtherPhoneNumber"
                                                                    id="OtherPhoneNumber"
                                                                    placeholder="(555) 555-5555"
                                                                    autoComplete="off"
                                                                    value={mainPatientModal.OtherPhoneNumber}
                                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                                    onChange={handlePatientChange}
                                                                />
                                                                {PatientValidationModal.OtherPhoneNumberlen}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className='form-group input mb-0'>
                                                            <label >Email</label>
                                                            <div className={PatientValidationModal.EmailAddressVal ? 'input error' : 'input'}>
                                                                <input
                                                                    type="text"
                                                                    className='form-control'
                                                                    name="Email"
                                                                    id="Email"
                                                                    autoComplete="off"
                                                                    maxLength={50}
                                                                    value={mainPatientModal.Email}
                                                                    onChange={handlePatientChange}
                                                                />
                                                                {PatientValidationModal.EmailAddressVal}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className='form-group input mb-0'>
                                                            <label >Fax Number</label>
                                                            <div className={PatientValidationModal.FaxNumberlen ? 'input error' : 'input'}>
                                                                <ReactInputMask
                                                                    maskChar={0}
                                                                    mask='999-999-9999'
                                                                    className='form-control'
                                                                    name="FaxNumber"
                                                                    id="FaxNumber"
                                                                    value={mainPatientModal.FaxNumber}
                                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                                    onChange={handlePatientChange}
                                                                />
                                                                {PatientValidationModal.FaxNumberlen}
                                                            </div>
                                                        </div>
                                                    </div>



                                                </div>
                                            </div>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion expanded={expanded === 'Pateint3-content'} onChange={handleChangeAccodian('Pateint3-content')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="Pateint3-content"
                                        id="address-header"
                                    >
                                        <p className="heading">Patient Preferences</p>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div className="row">

                                            <div className="col-md-3 mt-2">
                                                <div className='input'>
                                                    <label >Preferred Language</label>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='PreferredLanguage'
                                                        name='PreferredLanguage'
                                                        searchValue={mainPatientModal.PreferredLanguage}
                                                        data={PreferredLanguage}
                                                        onChange={handleChangeDD}
                                                        getSelectedData={handleSelectedData}
                                                        icon={'Simple'}
                                                        is={is}
                                                        sup_btn='sup_btn-Inp'
                                                        sup_inp='superSearchVisitInp'
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-3 mt-2">
                                                <div className='input'>
                                                    <label >Language Proficiency</label>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='LanguageProficiency'
                                                        name='LanguageProficiency'
                                                        searchValue={mainPatientModal.LanguageProficiency}
                                                        data={LanguageProficiencyDropdown}
                                                        onChange={handleChangeDD}
                                                        getSelectedData={handleSelectedData}
                                                        icon={'Simple'}
                                                        is={is}
                                                        sup_btn='sup_btn-Inp'
                                                        sup_inp='superSearchVisitInp'
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3 mt-2">
                                                <div className='input'>
                                                    <label >Preferred Communication</label>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='PreferredCommunication'
                                                        name='PreferredCommunication'
                                                        searchValue={mainPatientModal.PreferredCommunication}
                                                        data={PreferredCommunication}
                                                        onChange={handleChangeDD}
                                                        getSelectedData={handleSelectedData}
                                                        is={is}
                                                        icon={'Simple'}
                                                        sup_btn='sup_btn-Inp'
                                                        sup_inp='superSearchVisitInp'
                                                    />
                                                </div>
                                            </div>

                                        </div>

                                    </AccordionDetails>

                                </Accordion>
                                {isHomeCareCheck === 'true' ? (
                                    <Accordion defaultExpanded>
                                        <AccordionSummary
                                            aria-hidden='true'
                                            id="prac1-header"
                                            aria-controls="prac1-content"
                                            expandIcon={<ExpandMoreIcon />}
                                        >
                                            <p className="heading">Add Service Span <span className='text fs-11 ar-light-color fst-italic font-m'>Last Visit Done 5/2/2024 By: Munoz De Gorilla, Maria(001151)</span></p>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <div className='row row-half'>
                                                <div className="col-md-3 mt-2">
                                                    <div className='form-group input'>
                                                        <label >Medicaid #</label>
                                                        <div className='input'>
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                name="MedicaidNo"
                                                                id="MedicaidNo"
                                                                autoComplete="off"
                                                                maxLength={30}
                                                                value={mainPatientModal.MedicaidNo}
                                                                onChange={handlePatientChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3 mt-2">
                                                    <div className='form-group input'>
                                                        <label >Medicare #</label>
                                                        <div className='input'>
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                name="MedicareNo"
                                                                id="MedicareNo"
                                                                maxLength={30}
                                                                autoComplete="off"
                                                                value={mainPatientModal.MedicareNo}
                                                                onChange={handlePatientChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3 mt-2">
                                                    <div className={PatientValidationModal.LocationVal ? 'input error' : 'input'}>
                                                        {
                                                            !isNull(mainPatientModal.LocationID) ?
                                                                <>
                                                                    {LocationPopup}
                                                                </> :
                                                                <label>Location <span className='req'>*</span></label>
                                                        }
                                                        <SuperSearchList
                                                            type="client"
                                                            id='LocationID'
                                                            name='LocationID'
                                                            searchValue={mainPatientModal.LocationID}
                                                            data={DropDowns.Location}
                                                            onChange={handleChangeDD}
                                                            getSelectedData={handleSelectedData}
                                                            is={is}
                                                            sup_btn='sup_btn-Inp'
                                                            sup_inp='superSearchVisitInp'
                                                            inputError={PatientValidationModal.LocationVal}
                                                        />
                                                        {PatientValidationModal.LocationVal}
                                                    </div>
                                                </div>
                                                <div className="col-md-3 mt-2">
                                                    <div className='input'>
                                                        <label>Shift</label>
                                                        <SuperSearchList
                                                            type="client"
                                                            id='ShiftID'
                                                            name='ShiftID'
                                                            searchValue={mainPatientModal.ShiftID}
                                                            data={ShifDD}
                                                            onChange={handleChangeDD}
                                                            getSelectedData={handleSelectedData}
                                                            is={is}
                                                            sup_btn='sup_btn-Inp'
                                                            sup_inp='superSearchVisitInp'
                                                        // inputError={PatientValidationModal.LocationVal}
                                                        />
                                                        {/* {PatientValidationModal.LocationVal} */}
                                                    </div>
                                                </div>
                                                <div className="col-md-3 mt-2">
                                                    <div className='form-group input'>
                                                        <label >Request For Start Date</label>
                                                        <DatePicker
                                                            id="dobInput"
                                                            showLabel={false}
                                                            value={mainPatientModal.RequestStartDate}
                                                            handleCalendarChangefunc={date => handleCalendarChange(date, 'RequestStartDate')}
                                                        />
                                                    </div>
                                                </div>
                                                {/* <div className="col-md-3">
                                        <div className='input'>
                                            <label >Pharmacy</label>
                                            <select className='form-control'>
                                                <option>Pharmacy1</option>
                                                <option>Pharmacy2</option>
                                                <option>Pharmacy3</option>
                                            </select>
                                        </div>
                                    </div> */}
                                                {/* <div className="col-md-3 mt-2">
                                        <div className='input'>
                                            <label >Patientr</label>
                                            <select className='form-control'>
                                                <option>Patientr1</option>
                                                <option>Patientr2</option>
                                                <option>Patientr3</option>
                                            </select>
                                        </div>
                                    </div> */}
                                            </div>
                                            <div className='row row-half'>
                                                <div className="col-md-3 mt-2">
                                                    <div className='input'>
                                                        <label >Preferred Caregiver Gender</label>
                                                        <SuperSearchList
                                                            type="client"
                                                            id='PreferredCareGiverGender'
                                                            name='PreferredCareGiverGender'
                                                            searchValue={mainPatientModal.PreferredCareGiverGender}
                                                            data={GenderIdentity}
                                                            onChange={handleChangeDD}
                                                            getSelectedData={handleSelectedData}
                                                            is={is}
                                                            sup_btn='sup_btn-Inp'
                                                            sup_inp='superSearchVisitInp'
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-3 mt-2 align-content-end">
                                                    <div className='input'>
                                                        <label >Coordinator</label>
                                                        <SuperSearchList
                                                            type="client"
                                                            id='CoOrdinatorID'
                                                            name='CoOrdinatorID'
                                                            searchValue={mainPatientModal.CoOrdinatorID}
                                                            data={DropDowns.CoOrdinator}
                                                            onChange={handleChangeDD}
                                                            getSelectedData={handleSelectedData}
                                                            is={is}
                                                            sup_btn='sup_btn-Inp'
                                                            sup_inp='superSearchVisitInp'
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='row half-row'>
                                                <div className="col-md-6 mt-2 pateint-serach-no-rounded">
                                                    <div className="input">
                                                        <label >PA</label>
                                                        {/* <SuperSearchMultiple
                                                        type='server'
                                                        id="PA"
                                                        name='PA'
                                                        onSelect={handleMUltiSelectedData}    // use for get data 
                                                        initialSelectedValues={SuperListPA}
                                                        // onChange={handleChangeDD}
                                                        //
                                                        tableName={'CareGiver'}           //send Tablename api
                                                        searchTerm={mainPatientModal.PA} //for search ipnut 
                                                        ApiLink={API_URL_GENERAL + "/DropDown"} //api url 
                                                        method='post'                             //   api method 
                                                        // postBody={checkBody}
                                                        // onChange={handleCheckNumberChange}
                                                        sup_btn='sup_btn-Inp'
                                                        sup_inp='superSearchVisitInp'
                                                    /> */}
                                                        <SuperSearchMultipleServer
                                                            key={mainPatientModal.PA}
                                                            id="PA"
                                                            name="PA"
                                                            SuperSearchView="DetailedView"
                                                            DetailedView="Caregiver"
                                                            initialSelectedOptionsInstant={mainPatientModal.PA} // GETTING USED IN CASE OF INITIAL Value for Instant Search
                                                            searchParam={PatientSaveUpdateModal}
                                                            setSearchParam={setPatientSaveUpdateModal}
                                                            // onSelect={handleMUltiSelectedData}    // use for get data 
                                                            tableName={enumUtil.enumAPITableName.CareGiver} //send Tablename api
                                                            controller={API_URL_GENERAL}
                                                            ApiLink={"/InstantSearch"} //api url 
                                                            method='post'  //   api method
                                                            sup_btn='sup_btn-Inp'
                                                            sup_inp='superSearchVisitInp'
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6 mt-2 ar-multiple-br">
                                                    <div className="input">
                                                        <label >Marketer</label>
                                                        {/* <SuperSearchMultiple
                                                        type="client"
                                                        id="Marketer"
                                                        name="Marketer"
                                                        optionss={DropDowns.Marketer}
                                                        searchTerm={mainPatientModal.Marketer}
                                                        onSelect={handleMUltiSelectedData}
                                                        initialSelectedValues={Marketerr}
                                                        onChange={handlePatientChange}
                                                        sup_btn="sup_btn-Inp"
                                                        sup_inp="superSearchVisitInp"
                                                    /> */}
                                                        <SuperSearchMultipleClient
                                                            key={mainPatientModal.Marketer}
                                                            view={'MultiOptions'}
                                                            type="client"
                                                            id="Marketer"
                                                            name="Marketer"
                                                            selectedOptionsDisplay='Marketer'
                                                            initialSelectedValues={mainPatientModal.Marketer}
                                                            searchParam={PatientSaveUpdateModal}
                                                            setSearchParam={setPatientSaveUpdateModal}
                                                            options={DropDowns.Marketer?.filter(item => !['-1', -1].includes(item.value))}
                                                            sup_btn="sup_btn-Inp"
                                                            sup_inp="superSearchVisitInp"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                ) : (
                                    <Accordion defaultExpanded>
                                        <AccordionSummary
                                            aria-hidden='true'
                                            id="prac1-header"
                                            aria-controls="prac1-content"
                                            expandIcon={<ExpandMoreIcon />}
                                        >
                                            <p className="heading">Assigned Profiles</p>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <div className='row row-half'>
                                                {popup}
                                                <div className="col-md-3">
                                                    <div className={PatientValidationModal.LocationVal ? 'input error' : 'input'}>
                                                        {
                                                            !isNull(mainPatientModal.LocationID) ?
                                                                <>
                                                                    {LocationPopup}
                                                                    {/* <label>Location <span className='req'>*</span>  </label>s */}

                                                                </> :
                                                                <label>Location <span className='req'>*</span>  </label>
                                                        }
                                                        <SuperSearchList
                                                            type="client"
                                                            id='LocationID'
                                                            name='LocationID'
                                                            searchValue={mainPatientModal.LocationID}
                                                            data={DropDowns.Location}
                                                            onChange={handleChangeDD}
                                                            getSelectedData={handleSelectedData}
                                                            is={is}
                                                            sup_btn='sup_btn-Inp'
                                                            sup_inp='superSearchVisitInp'
                                                            inputError={PatientValidationModal.LocationVal}
                                                        />
                                                        {PatientValidationModal.LocationVal}
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className={PatientValidationModal.Providerval ? 'input error' : 'input'}>
                                                        {
                                                            !isNull(mainPatientModal.ProviderID) ?
                                                                <>
                                                                    {ProviderPopup}
                                                                </> :
                                                                <label>Provider  <span className='req'>*</span> </label>
                                                        }
                                                        <SuperSearchList
                                                            type="client"
                                                            id='ProviderID'
                                                            name='ProviderID'
                                                            searchValue={mainPatientModal.ProviderID}
                                                            data={DropDowns.Provider}
                                                            onChange={handleChangeDD}
                                                            getSelectedData={handleSelectedData}
                                                            is={is}
                                                            sup_btn='sup_btn-Inp'
                                                            sup_inp='superSearchVisitInp'
                                                            inputError={PatientValidationModal.Providerval}
                                                        // skipNextFocus={skipNextFocus}
                                                        // filterWith="startsWith"
                                                        // tableHeight="200px"
                                                        // tableWidth="100%"
                                                        />
                                                        {PatientValidationModal.Providerval}
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className='input'>
                                                        {
                                                            !isNull(mainPatientModal.RefProviderID) ?
                                                                <>
                                                                    {RefProviderPopup}
                                                                </> :
                                                                <label>Ref. Provider</label>
                                                        }
                                                        <SuperSearchList
                                                            type="client"
                                                            id='RefProviderID'
                                                            name='RefProviderID'
                                                            searchValue={mainPatientModal.RefProviderID}
                                                            data={DropDowns.RefProvider}
                                                            onChange={handleChangeDD}
                                                            getSelectedData={handleSelectedData}
                                                            is={is}
                                                            sup_btn='sup_btn-Inp'
                                                            sup_inp='superSearchVisitInp'
                                                        // filterWith="startsWith"
                                                        // tableHeight="200px"
                                                        // tableWidth="100%"
                                                        />
                                                    </div>
                                                </div>
                                                {/* <div className="col-md-3">
                                        <div className='input'>
                                            <label >Pharmacy</label>
                                            <select className='form-control'>
                                                <option>Pharmacy1</option>
                                                <option>Pharmacy2</option>
                                                <option>Pharmacy3</option>
                                            </select>
                                        </div>
                                    </div> */}
                                                {/* <div className="col-md-3 mt-2">
                                        <div className='input'>
                                            <label >Patientr</label>
                                            <select className='form-control'>
                                                <option>Patientr1</option>
                                                <option>Patientr2</option>
                                                <option>Patientr3</option>
                                            </select>
                                        </div>
                                    </div> */}
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                )}
                                {isHomeCareCheck === 'true' && (
                                    <Accordion expanded={expanded === 'prac2-header'} onChange={handleChangeAccodian('prac2-header')}>
                                        <AccordionSummary
                                            aria-hidden='true'
                                            id="prac2-header"
                                            aria-controls="prac2-content"
                                            expandIcon={<ExpandMoreIcon />}
                                        >
                                            <p className="heading">Admission</p>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <div className='row row-half'>
                                                <div className="col-md-3 mt-2 demograohics-input">
                                                    <div className='input'>
                                                        <label>Status</label>
                                                        <SuperSearchList
                                                            type="client"
                                                            id='AdmissionStatus'
                                                            name='AdmissionStatus'
                                                            searchValue={mainPatientAdmissionmodal.AdmissionStatus}
                                                            data={AdmissionStatusDropDown}
                                                            onChange={handleChangePatientAdmission}
                                                            getSelectedData={handleSelectedAdmissionData}
                                                            is={is}
                                                            icon={'Simple'}
                                                            sup_btn='sup_btn'
                                                            sup_inp='superSearchVisitInp'
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-3 mt-2">
                                                    <div className='form-group input'>
                                                        <label htmlFor="dobInput">Date <span className='req'>*</span></label>
                                                        <DatePicker
                                                            id="Date"
                                                            showLabel={false}
                                                            value={mainPatientAdmissionmodal.Date}
                                                            handleCalendarChangefunc={date => handleCalendarChangeadmission(date, 'Date')}
                                                        />

                                                    </div>
                                                </div>
                                                <div className="col-md-3 mt-2">
                                                    <div className='form-group input'>
                                                        <label >Source</label>
                                                        <div className='input'>
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                name="Source"
                                                                id="Source"
                                                                maxLength={30}
                                                                autoComplete='off'
                                                                value={mainPatientAdmissionmodal.Source}
                                                                onChange={handleChangePatientAdmission}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='row row-half'>
                                                <div className="form-group input col-md-12">
                                                    <label htmlFor="Description">Notes</label>
                                                    <textarea
                                                        className="form-control doc-textarea"
                                                        id="Notes"
                                                        name="Notes"
                                                        value={mainPatientAdmissionmodal.Notes}
                                                        onChange={handleChangePatientAdmission}
                                                    ></textarea>
                                                </div>
                                            </div>
                                            <div className='admition-table hk-expand-table BorderLess-table'>
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th className='heading w-auto text-nowrap'>Status</th>
                                                            <th className='heading w-auto w-100 text-nowrap'>Date</th>
                                                            <th className='heading w-auto w-100 text-nowrap'>Source</th>
                                                            <th className='heading w-auto w-100 text-nowrap'>Entered By</th>
                                                            <th className='heading w-auto w-100 text-nowrap'>Entered Date</th>
                                                            <th className='heading w-100'>Notes</th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {patientadmission.map((item) => (
                                                            <tr>
                                                                <td >
                                                                    <p className={`pill w-max-content ${item.AdmissionStatus === 'Active' ? 'ar-user_active' : item.AdmissionStatus === 'Hold' ? 'Hold' : item.AdmissionStatus === 'Discharged' ? 'Discharge' : item.AdmissionStatus === 'Hospitalization' ? 'Hospitalization' : item.AdmissionStatus === 'Vacation' ? 'Vacation' : ''}`}>{item.AdmissionStatus}</p>
                                                                </td>
                                                                <td className='text'>{item.Date}</td>
                                                                <td className='text'>{item.Source}</td>
                                                                <td className='text'>{item.EnteredBy}</td>
                                                                <td className='text'>{item.EnteredDate}</td>
                                                                <td className='text'>{item.Notes}</td>
                                                                <td className='text'>
                                                                    <div className='d-flex gap-1'>
                                                                        <i className='icon-Icon-material-edit' onClick={() => handleEditadmission(item)}></i>
                                                                        <i className='icon-delete' onClick={() => confirmDelete(item)}></i>
                                                                    </div>

                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                )
                                }

                                <Accordion expanded={expanded === 'LOC'} onChange={handleChangeAccodian('LOC')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="loc-content"
                                        id="loc-header"
                                    >
                                        <p className="heading">Level of Care</p>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div className='row row-half m-0 g-0 py-3px row-gap-8 align-items-end'>

                                            <div className="col-md-3 ps-0">
                                                <div className='input'>
                                                    <label>LOC Framework</label>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='LOCFramework'
                                                        name='LOCFramework'
                                                        searchValue={mainLOCModal.LOCFramework}
                                                        data={LOCFrameworkDropdown}
                                                        onChange={handleLOCChange}
                                                        getSelectedData={handleLOCFrameworkChange}
                                                        is={is}
                                                        icon={'Simple'}
                                                        sup_btn='sup_btn'
                                                        sup_inp='superSearchVisitInp'
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-9 pe-0">
                                                <div className={LOCValidationState.LevelOfCareVal ? 'input error' : 'input'}>
                                                    <label>Level of Care {isFrameworkSelected && <span className='req'>*</span>} </label>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='LevelOfCare'
                                                        name='LevelOfCare'
                                                        searchValue={mainLOCModal.LevelOfCare}
                                                        data={getLevelOfCareOptions()}
                                                        onChange={handleLOCChange}
                                                        getSelectedData={handleLOCLevelChange}
                                                        is={is}
                                                        icon={'Simple'}
                                                        sup_btn='sup_btn'
                                                        sup_inp='superSearchVisitInp'
                                                    // disabled={!mainLOCModal.LOCFramework}
                                                    />
                                                    {LOCValidationState.LevelOfCareVal}
                                                </div>
                                            </div>

                                            <div className="col-md-3 ps-0">
                                                <div className={LOCValidationState.StartDateVal ? 'input error' : 'input'}>
                                                    <label>Start Date {isFrameworkSelected && <span className='req'>*</span>}</label>
                                                    <DatePicker
                                                        id="locStartDate"
                                                        showLabel={false}
                                                        value={mainLOCModal.StartDate}
                                                        handleCalendarChangefunc={date => handleLOCDateChange(date, 'StartDate')}
                                                    />
                                                    {LOCValidationState.StartDateVal}
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <div className='input'>
                                                    <label>End Date</label>
                                                    <DatePicker
                                                        id="locEndDate"
                                                        showLabel={false}
                                                        value={mainLOCModal.EndDate}
                                                        handleCalendarChangefunc={date => handleLOCDateChange(date, 'EndDate')}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <div className={LOCValidationState.AttendingProviderVal ? 'input error' : 'input'}>
                                                    <label>Attending Provider {isFrameworkSelected && <span className='req'>*</span>}</label>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='AttendingProviderID'
                                                        name='AttendingProviderID'
                                                        searchValue={mainLOCModal.AttendingProviderID}
                                                        data={DropDowns.Provider || []}
                                                        onChange={handleLOCChange}
                                                        getSelectedData={(data, name, type) => handleLOCProviderChange(data, 'AttendingProviderID', type)}
                                                        is={is}
                                                        sup_btn='sup_btn-Inp'
                                                        sup_inp='superSearchVisitInp'
                                                        icon='Simple'
                                                    />
                                                    {LOCValidationState.AttendingProviderVal}
                                                </div>
                                            </div>

                                            <div className="col-md-3 pe-0">
                                                <div className='input'>
                                                    <label>Rendering Provider</label>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='RenderingProviderID'
                                                        name='RenderingProviderID'
                                                        searchValue={mainLOCModal.RenderingProviderID}
                                                        data={DropDowns.Provider || []}
                                                        onChange={handleLOCChange}
                                                        getSelectedData={(data, name, type) => handleLOCProviderChange(data, 'RenderingProviderID', type)}
                                                        is={is}
                                                        sup_btn='sup_btn-Inp'
                                                        sup_inp='superSearchVisitInp'
                                                        icon='Simple'
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-12 px-0">
                                                <div className='input'>
                                                    <label>Notes</label>
                                                    <textarea
                                                        className="form-control"
                                                        id="locNotes"
                                                        name="Notes"
                                                        rows="2"
                                                        value={mainLOCModal.Notes}
                                                        onChange={handleLOCChange}
                                                    ></textarea>
                                                </div>
                                            </div>

                                        </div>


                                        <div className='admition-table hk-expand-table BorderLess-table mt-12 overflow-auto'>
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th className='heading w-auto text-nowrap'>LOC Framework</th>
                                                        <th className='heading w-auto text-nowrap'>Level of Care</th>
                                                        <th className='heading w-auto text-nowrap'>Start Date</th>
                                                        <th className='heading w-auto text-nowrap'>End Date</th>
                                                        <th className='heading w-auto text-nowrap'>Attending Prov</th>
                                                        <th className='heading w-auto text-nowrap'>Rendering Prov</th>
                                                        <th className='heading w-100'>Notes</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {patientLOCHistory.map((item, index) => (

                                                        <tr key={index}>
                                                            <td className='text'>{item.LOCFramework}</td>
                                                            <td className='text'>{getLevelOfCareDisplay(item.LOCFramework, item.LevelOfCare)}</td>
                                                            <td className='text'>{item.StartDate}</td>
                                                            <td className='text'>{item.EndDate}</td>
                                                            <td className='text'>{item.AttendingProvider}</td>
                                                            <td className='text'>{item.RenderingProvider}</td>
                                                            <td className='text'>{item.LOCNotes}</td>
                                                        </tr>
                                                    ))}

                                                </tbody>
                                            </table>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>


                                <Accordion expanded={expanded === 'other'} onChange={handleChangeAccodian('other')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="other-content"
                                        id="other-header"
                                    >
                                        <p className="heading">Other Information</p>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div className='row row-half'>

                                            <div className="col-md-6">
                                                <div className="input race">
                                                    <label >Race</label>

                                                    {/* <SuperSearchMultipleClient
                                                    key={mainPatientModal.Race}
                                                    view={'MultiOptions'}
                                                    type="client"
                                                    id="Race"
                                                    name="Race"
                                                    selectedOptionsDisplay='Race'
                                                    initialSelectedValues={race}
                                                    searchParam={PatientSaveUpdateModal}
                                                    setSearchParam={setPatientSaveUpdateModal}
                                                    options={Races?.filter(item => !['-1', -1].includes(item.value))}
                                                    sup_btn="sup_btn-Inp"
                                                    sup_inp="superSearchVisitInp"
                                                /> */}
                                                    <SuperSearchMultipleTest
                                                        key={mainPatientModal.Race}
                                                        view={'MultiOptions'}
                                                        type="client"
                                                        id="Race"
                                                        name="Race"
                                                        selectedOptionsDisplay='Race'
                                                        initialSelectedValues={race}
                                                        searchParam={PatientSaveUpdateModal}
                                                        setSearchParam={setPatientSaveUpdateModal}
                                                        options={Races?.filter(item => !['-1', -1].includes(item.value))}
                                                        sup_btn="sup_btn-Inp"
                                                        sup_inp="superSearchVisitInp"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 Ethnicity">
                                                <div className="input">
                                                    <label >Ethnicity</label>
                                                    <SuperSearchMultipleTest
                                                        key={mainPatientModal.Ethnicity}
                                                        view={'MultiOptions'}
                                                        type="client"
                                                        id="Ethnicity"
                                                        name="Ethnicity"
                                                        selectedOptionsDisplay='Ethnicity'
                                                        initialSelectedValues={ethnicity}
                                                        searchParam={PatientSaveUpdateModal}
                                                        setSearchParam={setPatientSaveUpdateModal}
                                                        options={Ethnicity?.filter(item => !['-1', -1].includes(item.value))}
                                                        sup_btn="sup_btn-Inp"
                                                        sup_inp="superSearchVisitInp"
                                                    />
                                                    {/* </div> */}
                                                </div>
                                                {/* <div className='input'>
                                                <label>Ethnicity</label>
                                                <SuperSearchList
                                                    type="client"
                                                    id='Ethnicity'
                                                    name='Ethnicity'
                                                    searchValue={mainPatientModal.Ethnicity}
                                                    data={Ethnicity}
                                                    onChange={handleChangeDD}
                                                    getSelectedData={handleSelectedData}
                                                    is={is}
                                                    sup_btn='sup_btn-Inp'
                                                    sup_inp='superSearchVisitInp'
                                                // filterWith="startsWith"
                                                // tableHeight="200px"
                                                // tableWidth="100%"
                                                />
                                            </div> */}
                                            </div>
                                            {/* <div className="col-md-3 mt-2 demograohics-input">
                                            <div className='input'>
                                                <label >Smoking Status</label>
                                                <SuperSearchList
                                                    type="client"
                                                    id='SmokingStatus'
                                                    name='SmokingStatus'
                                                    searchValue={mainPatientModal.SmokingStatus}
                                                    data={SmokingStatusDropdown}
                                                    onChange={handleChangeDD}
                                                    getSelectedData={handleSelectedData}
                                                    is={is}
                                                    icon={'Simple'}
                                                    sup_btn='sup_btn'
                                                    sup_inp='superSearchVisitInp'
                                                />
                                            </div>
                                        </div> */}
                                            <div className="col-md-3 mt-2 demograohics-input">
                                                <div className='input'>
                                                    <label >Employment Status</label>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='EmploymentStatus'
                                                        name='EmploymentStatus'
                                                        searchValue={mainPatientModal.EmploymentStatus}
                                                        data={EmploymentStatus}
                                                        onChange={handleChangeDD}
                                                        getSelectedData={handleSelectedData}
                                                        is={is}
                                                        icon={'Simple'}
                                                        sup_btn='sup_btn'
                                                        sup_inp='superSearchVisitInp'
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3 mt-2">
                                                <div className='input'>
                                                    <label >Student Status</label>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='StudentStatus'
                                                        name='StudentStatus'
                                                        searchValue={mainPatientModal.StudentStatus}
                                                        data={StudentStatus}
                                                        onChange={handleChangeDD}
                                                        getSelectedData={handleSelectedData}
                                                        is={is}
                                                        icon={'Simple'}
                                                        sup_btn='sup_btn'
                                                        sup_inp='superSearchVisitInp'
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3 mt-2 demograohics-input">
                                                <div className='input'>
                                                    <label>Class</label>
                                                    <input
                                                        type="text"
                                                        className='form-control'
                                                        name="Class"
                                                        id="Class"
                                                        autoComplete="off"
                                                        value={mainPatientModal.Class}
                                                        onChange={handlePatientChange}
                                                    />
                                                </div>
                                                {/* <div className='input'>
                                                <label >Class</label>

                                                <SuperSearchList
                                                    type="client"
                                                    id='Class'
                                                    name='Class'
                                                    searchValue={mainPatientModal.Class}
                                                    data={Class}
                                                    onChange={handleChangeDD}
                                                    getSelectedData={handleSelectedData}
                                                    is={is}
                                                    icon={'Simple'}
                                                    sup_btn='sup_btn'
                                                    sup_inp='superSearchVisitInp'
                                                />
                                            </div> */}
                                            </div>
                                            <div className="col-md-3 mt-2 demograohics-input">
                                                <div className='input'>
                                                    <label >Blood Group</label>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='BloodGroup'
                                                        name='BloodGroup'
                                                        searchValue={mainPatientModal.BloodGroup}
                                                        data={BloodGroup}
                                                        onChange={handleChangeDD}
                                                        getSelectedData={handleSelectedData}
                                                        is={is}
                                                        icon={'Simple'}
                                                        sup_btn='sup_btn'
                                                        sup_inp='superSearchVisitInp'
                                                    />
                                                </div>
                                            </div>
                                            {/*  */}


                                            <div className="col-md-3 mt-2 demograohics-input">
                                                <div className='input'>

                                                    <div className='d-flex align-items-center justify-content-between'>
                                                        <label >Sexual Orientation</label>
                                                        {/* <NoteIcon /> */}
                                                        <span className={` icon-note-icon fs-14`} onClick={handleOpenNotesPopup}><span class="path1"></span><span class="path2"></span></span>
                                                    </div>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='SexualOrientation'
                                                        name='SexualOrientation'
                                                        searchValue={mainPatientModal.SexualOrientation}
                                                        data={SexualOrientation}
                                                        onChange={handleChangeDD}
                                                        getSelectedData={handleSelectedData}
                                                        is={is}
                                                        icon={'Simple'}
                                                        sup_btn='sup_btn'
                                                        sup_inp='superSearchVisitInp'
                                                    />
                                                </div>
                                            </div>
                                            {/* */}

                                            <div className="col-md-3 mt-2">
                                                <div className='input'>
                                                    <label>Mother’s First Name</label>
                                                    <input
                                                        type="text"
                                                        className='form-control'
                                                        name="MotherFirstName"
                                                        id="MotherFirstName"
                                                        autoComplete="off"
                                                        value={mainPatientModal.MotherFirstName}
                                                        onChange={handlePatientChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3 mt-2">
                                                <div className='input'>
                                                    <label>Mother’s Maiden Name</label>
                                                    <input
                                                        type="text"
                                                        className='form-control'
                                                        name="MotherMedianName"
                                                        id="MotherMedianName"
                                                        autoComplete="off"
                                                        value={mainPatientModal.MotherMedianName}
                                                        onChange={handlePatientChange}
                                                    />
                                                </div>
                                            </div>
                                            {/* <div className="col-md-3 mt-2 demograohics-input">
                                            <div className='input'>
                                                <label >Gender Identity</label>
                                                <SuperSearchList
                                                    type="client"
                                                    id='GenderIdentity'
                                                    name='GenderIdentity'
                                                    searchValue={mainPatientModal.GenderIdentity}
                                                    data={GenderIdentity}
                                                    onChange={handleChangeDD}
                                                    getSelectedData={handleSelectedData}
                                                    is={is}
                                                    icon={'Simple'}
                                                    sup_btn='sup_btn'
                                                    sup_inp='superSearchVisitInp'
                                                />
                                            </div>
                                        </div> */}

                                            {/*  */}

                                            <div className="col-md-3 mt-2 demograohics-input">
                                                <div className='input'>
                                                    <label >Birth Order</label>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='BirthOrder'
                                                        name='BirthOrder'
                                                        searchValue={mainPatientModal.BirthOrder}
                                                        data={BirthOrder}
                                                        onChange={handleChangeDD}
                                                        getSelectedData={handleSelectedData}
                                                        is={is}
                                                        icon={'Simple'}
                                                        sup_btn='sup_btn'
                                                        sup_inp='superSearchVisitInp'
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3 mt-2">
                                                <div className='input'>
                                                    <label>Birth City</label>
                                                    <input
                                                        type="text"
                                                        className='form-control'
                                                        name="BirthCity"
                                                        id="BirthCity"
                                                        autoComplete="off"
                                                        value={mainPatientModal.BirthCity}
                                                        onChange={handlePatientChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3 mt-2">
                                                <div className='input'>
                                                    <label>Patient Referral Source</label>
                                                    <input
                                                        type="text"
                                                        className='form-control'
                                                        name="PatientReferralSource"
                                                        id="PatientReferralSource"
                                                        autoComplete="off"
                                                        value={mainPatientModal.PatientReferralSource}
                                                        onChange={handlePatientChange}
                                                    />
                                                </div>
                                                {/* <div className='input'>
                                                <label>Patient Referral Source</label>
                                                <select className='form-control'>
                                                    <option>Option</option>
                                                </select>
                                            </div> */}
                                            </div>
                                            {/* */}



                                            {/* <div className="col-md-3 mt-2">
                                            <div className='input'>
                                                <label>Hispanic or Latino</label>
                                                <select className='form-control'>
                                                    <option>Option</option>
                                                </select>
                                            </div>
                                        </div> */}

                                            <div className="col-md-12 mt-2">
                                                <div className='d-flex gap-3 flex-wrap'>
                                                    <div className='d-flex align-items-center gap-6'>
                                                        <div className="custom_check_box d-flex">
                                                            <input type="checkbox"
                                                                className="form-check-input m-0 p-0"
                                                                name="MultipleBirth"
                                                                id="MultipleBirth"
                                                                autoComplete="off"
                                                                checked={mainPatientModal.MultipleBirth}
                                                                onChange={handlePatientChange}
                                                            />
                                                        </div>
                                                        <p className="text font-m" for="inlineCheckbox1">Multiple Birth</p>
                                                    </div>

                                                    <div className='d-flex align-items-center gap-6'>
                                                        <div className="custom_check_box d-flex">
                                                            <input type="checkbox"
                                                                className="form-check-input m-0 p-0"
                                                                name="Pregnancy"
                                                                id="Pregnancy"
                                                                autoComplete="off"
                                                                checked={mainPatientModal.Pregnancy}
                                                                onChange={handlePatientChange}
                                                            />
                                                        </div>
                                                        <p className="text font-m" for="inlineCheckbox2">Pregnancy</p>

                                                    </div>
                                                    <div className='d-flex align-items-center gap-6'>
                                                        <div className="custom_check_box d-flex">
                                                            <input type="checkbox"
                                                                className="form-check-input m-0 p-0"
                                                                name="SignatureOnFile"
                                                                id="SignatureOnFile"
                                                                autoComplete="off"
                                                                checked={mainPatientModal.SignatureOnFile}
                                                                onChange={handlePatientChange}
                                                            />
                                                        </div>
                                                        <p className="text font-m" for="inlineCheckbox4">Signature on File</p>

                                                    </div>
                                                    <div className='d-flex align-items-center gap-6'>
                                                        <div className="custom_check_box d-flex">
                                                            <input type="checkbox"
                                                                className="form-check-input m-0 p-0"
                                                                name="ReleaseOfFile"
                                                                id="ReleaseOfFile"
                                                                autoComplete="off"
                                                                checked={mainPatientModal.ReleaseOfFile}
                                                                onChange={handlePatientChange}
                                                            />
                                                        </div>
                                                        <p className="text font-m" for="inlineCheckbox4">Release of File</p>

                                                    </div>
                                                    <div className='d-flex align-items-center gap-6'>
                                                        <div className="custom_check_box d-flex">
                                                            <input type="checkbox"
                                                                className="form-check-input m-0 p-0"
                                                                name="IsDeceased"
                                                                id="IsDeceased"
                                                                autoComplete="off"
                                                                checked={mainPatientModal.IsDeceased}
                                                                onChange={handlePatientChange}
                                                            />
                                                        </div>
                                                        <p className="text font-m" for="inlineCheckbox3">Is Deceased </p>
                                                    </div>
                                                    <div className='d-flex align-items-center gap-6'>
                                                        <div className="custom_check_box d-flex">
                                                            <input type="checkbox"
                                                                className="form-check-input m-0 p-0"
                                                                name="ExcludeFromReporting"
                                                                id="ExcludeFromReporting"
                                                                autoComplete="off"
                                                                checked={mainPatientModal.ExcludeFromReporting}
                                                                onChange={handlePatientChange}
                                                            />
                                                        </div>
                                                        <p className="text font-m" for="inlineCheckbox6">Exclude From Reporting </p>
                                                    </div>
                                                    <div className='d-flex align-items-center gap-6'>
                                                        <div className="custom_check_box d-flex">
                                                            <input type="checkbox"
                                                                className="form-check-input m-0 p-0"
                                                                name="HoldSubmission"
                                                                id="HoldSubmission"
                                                                autoComplete="off"
                                                                checked={mainPatientModal.HoldSubmission === "true" || mainPatientModal.HoldSubmission === true}
                                                                onChange={handlePatientChange}
                                                            />
                                                        </div>
                                                        <p className="text font-m" for="inlineCheckbox6">Hold Submission </p>
                                                    </div>
                                                    <div className='d-flex align-items-center gap-6'>
                                                        <div className="custom_check_box d-flex">
                                                            <input type="checkbox"
                                                                className="form-check-input m-0 p-0"
                                                                name="HoldStatement"
                                                                id="HoldStatement"
                                                                autoComplete="off"
                                                                checked={mainPatientModal.HoldStatement}
                                                                onChange={handlePatientChange}
                                                            />
                                                        </div>
                                                        <p className="text font-m" for="inlineCheckbox6">Hold Statement </p>
                                                    </div>
                                                </div>

                                            </div>
                                            {mainPatientModal.IsDeceased && (
                                                <>
                                                    <div className="col-md-3">
                                                        <DatePicker
                                                            label='Date Of Death'
                                                            value={mainPatientModal.DateOfDeath}
                                                            handleCalendarChangefunc={date => handleCalendarChange(date, 'DateOfDeath')}
                                                        />
                                                    </div>
                                                    <div className="col-md-9">
                                                        <div className='input'>
                                                            <label>Cause of Death</label>
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                name="CauseOfDeath"
                                                                id="CauseOfDeath"
                                                                autoComplete="off"
                                                                value={mainPatientModal.CauseOfDeath}
                                                                onChange={handlePatientChange}
                                                            />
                                                        </div>
                                                    </div>

                                                </>
                                            )}

                                            {mainPatientModal?.ExcludeFromReporting === true || mainPatientModal?.ExcludeFromReporting === 'true'
                                                ?
                                                <div className="col-md-6">
                                                    <div className='input'>
                                                        <label>Exclude From Reporting Notes</label>
                                                        <input
                                                            type="text"
                                                            className='form-control'
                                                            name="ExcludeFromReportingNotes"
                                                            id="ExcludeFromReportingNotes"
                                                            autoComplete="off"
                                                            value={mainPatientModal.ExcludeFromReportingNotes}
                                                            onChange={handlePatientChange}
                                                        />
                                                    </div>
                                                </div>

                                                : null
                                            }
                                            {mainPatientModal?.HoldSubmission === true || mainPatientModal?.HoldSubmission === 'true'
                                                ?
                                                <div className="col-md-6">
                                                    <div className={PatientValidationModal.HoldSubmissionNotesval ? ' input error' : 'input'}>
                                                        <label>Hold Submission Notes  <span className='req'>*</span></label>
                                                        <input
                                                            type="text"
                                                            className='form-control'
                                                            name="HoldSubmissionNotes"
                                                            id="HoldSubmissionNotes"
                                                            autoComplete="off"
                                                            value={mainPatientModal.HoldSubmissionNotes}
                                                            onChange={handlePatientChange}
                                                        />
                                                        {PatientValidationModal.HoldSubmissionNotesval}
                                                    </div>
                                                </div>
                                                : null
                                            }
                                            {mainPatientModal?.HoldStatement === true || mainPatientModal?.HoldStatement === 'true'
                                                ? <div className="col-md-6">
                                                    <div className={PatientValidationModal.HoldStatementNotesval ? ' input error' : 'input'}>
                                                        <label>Hold Statement Notes <span className='req'>*</span></label>
                                                        <input
                                                            type="text"
                                                            className='form-control'
                                                            name="HoldStatementNotes"
                                                            id="HoldStatementNotes"
                                                            autoComplete="off"
                                                            value={mainPatientModal.HoldStatementNotes}
                                                            onChange={handlePatientChange}
                                                        />
                                                        {PatientValidationModal.HoldStatementNotesval}
                                                    </div>
                                                </div>
                                                : null
                                            }
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                            {isOpenMissing &&
                                <div className='missing_detail'>
                                    <div className='demo missing_data'>
                                        <span className='d-flex align-items-center'>
                                            <span class="icon-Group-4785"><span class="path1 fs-18"></span><span class="path2 "></span><span class="path3 "></span></span>
                                            Demographic have some data missing <span className='detail border-0'><i className=' cursor-pointer ms-5 icon-Icon-metro-cross' onClick={() => setIsOpenMissing(false)}></i></span>
                                        </span>
                                        <div className='message_list'>
                                            {missingDataInfo.map((item) => {
                                                return (
                                                    <p className='text'>{item}</p>
                                                )
                                            })}
                                            {/* <p className='text'>Patient Address is missing.</p>
                                        <p className='text'>Patient DOB is missing.</p>
                                        <p className='text'>Patient Address is missing.</p> */}
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    <Modal show={notesPopup} onHide={notesPopup} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_export-excel_popup"
                    >
                        <Modal.Body>
                            <ModalHeader HeaderName={AddNotesName} DeletePopup={''} isClosed={handleNotesPopupClose} />
                            <div className="input">
                                <label className="pb-3px">Notes</label>
                                <textarea rows="3" className="form-control" id='SexualOrientationNotes' name='SexualOrientationNotes' value={mainPatientModal?.SexualOrientationNotes}
                                    onChange={handlePatientChange}></textarea>
                            </div>
                        </Modal.Body>
                        <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                            <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={handleNotesPopupClose}>Cancel</button>
                            <button className='btn btn-validate px-10 h-100' onClick={handleSavePatient}>Save</button>
                        </div>
                    </Modal>
                    <Modal show={notesGenderPopup} onHide={notesGenderPopup} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_export-excel_popup"
                    >
                        <Modal.Body>
                            <ModalHeader HeaderName={AddNotesName} DeletePopup={''} isClosed={handleGenderNotesPopupClose} />
                            <div className="input">
                                <label className="pb-3px">Notes <span className='req'>*</span></label>
                                <div className={PatientValidationModal.GenderIdentityNotesVal ? 'form-group input error' : 'form-group input'}>
                                    <textarea rows="3" className="form-control" id='GenderIdentityNotes' name='GenderIdentityNotes'
                                        value={mainPatientModal.GenderIdentityNotes}
                                        onChange={handlePatientChange}></textarea>

                                    {PatientValidationModal.GenderIdentityNotesVal}
                                </div>

                            </div>
                        </Modal.Body>
                        <ModalFooter isSaved={handleGenderNotesPopupClose} handleSave={handleSavePatient} key={'AddNotes'} Name={'AddNotes'} UpdatedDate={''} UpdatedBy={''} ID={''} IsEditAllowed={true} />

                        {/* <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                        <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={handleGenderNotesPopupClose}>Cancel</button>
                        <button className='btn btn-validate px-10 h-100' onClick={handleSavePatient}>Save</button>
                    </div> */}
                    </Modal>
                    <div className='tabs-action-bottom br-top-1 br-bottom-1 br-clr justify-content-between d-flex py-2 position-static'>
                        <div className='col-md-3'>
                            <div className='ms-3 py-1'>
                                <p className='heading heading_ext d-flex align-items-center gap-01'>Updated By/Date: <span className='text text_color'>{!isNull(mainPatientModal.CreatedBy) ? mainPatientModal.CreatedBy + ', ' + mainPatientModal.CreatedDate : 'N/A'}</span></p>
                            </div>
                        </div>
                        <div className='col-md-1-5'>
                            <div className="position-relative">
                                {PatientID > 0 ? <>
                                    {isNull(mainPatientModal.ErrorMessages) ?
                                        <div className='demo mt-1'>
                                            <span > <i className='icon-check-circle'></i> Demographics are complete</span>
                                        </div>
                                        :
                                        <div className='demo missing_data'>
                                            <span className='d-flex align-items-center'>
                                                <span class="icon-Group-4785"><span class="path1 fs-18"></span><span class="path2 "></span><span class="path3 "></span></span>
                                                Demographic have some data missing <span className='detail cursor-pointer' onClick={handleOpenMissingData}><i className='icon-arrow-right2'></i></span>
                                            </span>
                                        </div>
                                    }
                                </> : null}
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className='btns-group text-end px-3  d-flex align-items-center justify-content-end py-1'>
                                <button className={IsEditAllowed ? 'btn btn-orange m-0' : 'btn btn-orange m-0 disabled'} onClick={handleSavePatient}>Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            <Modal show={isProviderActive}
                onHide={null}
                backdrop="static"
                keyboard={false}
                centered
                dialogClassName="app-modal hk-modal-v1 ar_select_opt  za-update-subscriber-id za-discard-changes za-exit-group" >
                <ModalHeader HeaderName={AddIsPorvider} DeletePopup={""} isClosed={() => setIsProviderActive(false)} key={631} Name={'Discard'} />
                <Modal.Body>
                    <div className='ar-alert d-flex mb-1'>
                        <i className='icon-alert mt-1'></i>
                        <div>
                            <p className='text ms-1'>The selected provider is currently inactive. Are you sure you want to assign this provider to the patient?</p>
                        </div>
                    </div>
                </Modal.Body>
                <div className='modal_footer za_br_light br-top-1 pt-2'>
                    <div className='za-button text-end d-flex justify-content-end gap-2'>
                        <button className='btn btn-outline fs-12 px-10 rounded drk_clr' onClick={handleCancelProvider}>Cancel</button>
                        <button className='btn btn-danger fs-12 px-10 rounded' onClick={() => handleAssignInActiveProvider()}>Assign <i className='icon-arrow-right2 '></i></button>
                    </div>
                </div>
                <div>

                </div>
            </Modal>
        </>
    );
}
export default Demographics
